import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { connect } from "react-redux";
import PageTitle from "../common/PageTitle";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "./ProcedureListing.css";
import {
  EPRESCRIPTION,
  PROCEDURE_CONSTANTS_DETAILS,
} from "../../shared/constants";
import {
  LAB_ADMIN,
  PRINT_FILE,
  PRINT_PREVIEW,
  RADIOLOGY,
  ROLE_KEYS,
  X_RAY,
} from "../../shared/constants";
import BtnCellRenderer from "../common/BtnCellRenderer";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import DescriptionIcon from "@mui/icons-material/Description";
import MedicationIcon from "@mui/icons-material/Medication";
import HandymanIcon from "@mui/icons-material/Handyman";
import {
  CFollowupNote,
  DFollowupNote,
  GET_UPLOAD_PATH,
  GET_UPLOAD_HOSPITAL_PATH,
  GET_LAB_PATH,
  MULTILABREPORTS,
  DIAGNOSIS,
  VITAL_SIGNS,
  UPLOAD,
} from "../../shared/constants";
import { jsonSchema } from "../../shared/schema";
import {
  patientActions,
  doctorActions,
  zoomActions,
  ehrActions,
} from "../../core/actions";
import { useDispatch, useSelector } from "react-redux";
import { helperServices } from "../../shared/helper";
import { DISCHARGESUMMARY, CASERECORD } from "../../shared/constants";
import {
  LABREPORT,
  RADIOLOGYREPORT,
  LAB,
  ULTRASOUND,
} from "../../shared/constants";
import { markForDel } from "../../core/actions/patientActions";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Alert } from "@mui/material";
import { Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import {
  Button,
  DialogContent,
  Menu,
  MenuItem,
  Select,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import { Grid, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import { format } from "date-fns";
import Components from "..";
import { Component } from "ag-grid-community";
import { Link } from "react-router-dom";
import { lowerCase, template } from "lodash";
import { list } from "suneditor/src/plugins";
import { useOrganization } from "../../configurations/OrganizationContext";
import { openDoctorPrint } from "../../vm/VedamaayuDoctorPrint";
import { openNursePrint } from "../../vm/VedamaayuNursePrint";
import {
  generatePatientCaseStudyPdf,
  openPatientCaseStudyPdfTab,
  renderPatientCaseStudyPdfTab,
} from "../../vm/VedamaayuPatientCaseStudyPrint";
import PrintPainAssessment from "./print/PrintPainAssessment";
import { patientServices } from "../../core/services";
import {
  ConsentFormStatus,
  ORG_CODES,
  All_Component_Name,
  FormGroupName,
} from "../../shared/constants";
import {
  isCaseStudyDateClass,
  isCaseStudyNotesClass,
  parseCaseStudyData,
} from "../../shared/helper/caseStudyUtils";

const { PROCEDURE_GROUPNAME_PATIENT_CASE_STUDY } =
  PROCEDURE_CONSTANTS_DETAILS;
const PAIN_ASSESSMENT_GROUP = FormGroupName.Pain_Assessment_Form;

const PainAssessmentActions = ({
  assessment,
  canEdit,
  completing,
  onComplete,
  onEdit,
  onPrint,
}) => {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const isCompleted = assessment.status === ConsentFormStatus.completed;

  return (
    <div
      style={{ alignItems: "center", display: "flex", gap: 2 }}
      onClick={(event) => event.stopPropagation()}
    >
      {canEdit && !isCompleted && (
        <IconButton
          aria-label="Edit Pain Assessment"
          color="primary"
          size="small"
          title="Edit Pain Assessment"
          onClick={onEdit}
        >
          <span className="material-icons" style={{ fontSize: 18 }}>
            edit
          </span>
        </IconButton>
      )}

      <IconButton
        aria-label="Print Pain Assessment"
        color="primary"
        size="small"
        title="Print Pain Assessment"
        onClick={onPrint}
      >
        <span className="material-icons" style={{ fontSize: 18 }}>
          print
        </span>
      </IconButton>

      {canEdit && !isCompleted && (
        <>
          <IconButton
            aria-label="More Pain Assessment actions"
            disabled={completing}
            size="small"
            title="More actions"
            onClick={(event) => setMenuAnchor(event.currentTarget)}
          >
            <span className="material-icons" style={{ fontSize: 19 }}>
              more_vert
            </span>
          </IconButton>
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={() => setMenuAnchor(null)}
          >
            <MenuItem
              disabled={completing}
              onClick={(event) => {
                event.stopPropagation();
                setMenuAnchor(null);
                onComplete();
              }}
            >
              <span className="material-icons mr-2" style={{ fontSize: 18 }}>
                check_circle
              </span>
              Complete
            </MenuItem>
          </Menu>
        </>
      )}
    </div>
  );
};

const normalizeProcedureGroup = (groupname) =>
  String(groupname || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

const isPainAssessmentProcedure = (procedure) =>
  normalizeProcedureGroup(procedure?.groupname) === PAIN_ASSESSMENT_GROUP;

const getProcedureTemplateId = (procedure) => {
  if (procedure?.templateId) return String(procedure.templateId).trim();
  if (typeof procedure?.notes !== "string") return "";

  const notes = procedure.notes.trim();
  if (!notes.startsWith("{")) return "";

  try {
    return String(
      JSON.parse(notes)?.archetype_details?.template_id?.value || "",
    ).trim();
  } catch {
    return "";
  }
};

const isDiagnosisOrVitalSignsProcedure = (procedure) => {
  const templateId = getProcedureTemplateId(procedure).toLowerCase();
  return (
    templateId === String(DIAGNOSIS).toLowerCase() ||
    templateId === String(VITAL_SIGNS).toLowerCase()
  );
};

const isNonPainConsentProcedure = (procedure) => {
  const normalizedGroup = normalizeProcedureGroup(procedure?.groupname);
  return (
    normalizedGroup !== PAIN_ASSESSMENT_GROUP &&
    normalizedGroup.includes("consent")
  );
};

// Join the Date and Notes procedure rows that belong to one Case Study.
const getCaseStudyGroupKey = (procedure) =>
  procedure?.subgroup
    ? `${procedure.patientId}_${procedure.visitId}_${procedure.subgroup}`
    : `legacy-${procedure?.id}`;

const getPainAssessmentGroupKey = (procedure) =>
  procedure?.subgroup
    ? `${procedure.patientId}_${procedure.visitId}_${procedure.subgroup}`
    : `legacy-${procedure?.id}`;

const buildPainAssessment = (procedures, sourceProcedure) => {
  const groupKey = getPainAssessmentGroupKey(sourceProcedure);
  const groupedRows = (procedures || []).filter(
    (procedure) =>
      isPainAssessmentProcedure(procedure) &&
      !procedure.markForDel &&
      getPainAssessmentGroupKey(procedure) === groupKey,
  );

  if (groupedRows.length === 0) return null;

  const valuesByClass = groupedRows.reduce((values, row) => {
    values[row.claSS] = row.notes;
    return values;
  }, {});
  const rowIdsByClass = groupedRows.reduce((rowIds, row) => {
    rowIds[row.claSS] = row.id;
    return rowIds;
  }, {});
  const timestamps = groupedRows
    .map((row) => row.udt || row.cdt)
    .filter(Boolean)
    .map((value) => new Date(value))
    .filter((value) => !Number.isNaN(value.getTime()));
  const latestTimestamp = timestamps.length
    ? new Date(Math.max(...timestamps.map((value) => value.getTime())))
        .toISOString()
    : sourceProcedure.udt || sourceProcedure.cdt;

  return {
    subgroup: sourceProcedure.subgroup,
    patientId: sourceProcedure.patientId,
    visitId: sourceProcedure.visitId,
    patientName: valuesByClass.PatientName || "",
    age: valuesByClass.Age || "",
    gender: valuesByClass.Gender || "",
    doctorName: valuesByClass.DoctorName || "Not available",
    examDateTime: valuesByClass.ExamDateTime || "",
    diagnosis: valuesByClass.Diagnosis || "",
    painScore: valuesByClass.PainScore || "0",
    doctorSignature: valuesByClass.DoctorSignature || "",
    doctorSignedAt: valuesByClass.DoctorSignedAt || "",
    status: valuesByClass.status || ConsentFormStatus.inprogress,
    statusRowId: rowIdsByClass.status,
    updatedAt: latestTimestamp,
  };
};

const getDoctorDisplayName = (doctor) => {
  const fullName = helperServices.getFullName(
    doctor?.first_name || "",
    null,
    doctor?.last_name || "",
  );

  return (
    `${doctor?.displaytitle || ""} ${fullName}` +
    `${
      doctor?.department
        ? `, Dep of ${doctor.department}`
        : ""
    }` +
    `${
      doctor?.qualification
        ? ` (${doctor.qualification})`
        : ""
    }`
  ).trim();
};

// Convert selected procedure rows into printable/displayable Case Studies.
const buildSelectedCaseStudies = ({
  allProcedures,
  selectedProcedures,
  doctors,
}) => {
  const selectedKeys = new Set(
    selectedProcedures.map(getCaseStudyGroupKey),
  );
  const doctorNamesById = (doctors || []).reduce(
    (result, doctor) => {
      result[String(doctor.personId)] =
        getDoctorDisplayName(doctor);
      return result;
    },
    {},
  );
  const groupedStudies = new Map();

  (allProcedures || [])
    .filter(
      (procedure) =>
        procedure.groupname === PROCEDURE_GROUPNAME_PATIENT_CASE_STUDY &&
        !procedure.markForDel &&
        selectedKeys.has(getCaseStudyGroupKey(procedure)),
    )
    .forEach((procedure) => {
      const key = getCaseStudyGroupKey(procedure);

      if (!groupedStudies.has(key)) {
        groupedStudies.set(key, {
          subgroup: procedure.subgroup || key,
          patientId: procedure.patientId,
          visitId: procedure.visitId,
          date: "",
          createdAt: "",
          notes: "",
          doctorId: procedure.doctorId,
          doctorName: "",
        });
      }

      const study = groupedStudies.get(key);
      study.doctorId = study.doctorId || procedure.doctorId;
      study.doctorName =
        study.doctorName || procedure.preparedBy || "";
      if (
        procedure.cdt &&
        (!study.createdAt ||
          new Date(procedure.cdt) < new Date(study.createdAt))
      ) {
        study.createdAt = procedure.cdt;
      }

      if (isCaseStudyDateClass(procedure.claSS)) {
        study.date = procedure.notes || "";
        return;
      }

      if (isCaseStudyNotesClass(procedure.claSS)) {
        const rawNotes = String(procedure.notes || "").trim();

        if (rawNotes.startsWith("{")) {
          const legacyStudy = parseCaseStudyData(
            procedure.notes,
            procedure.longdesc,
          );
          study.date = legacyStudy.date || study.date;
          study.notes = legacyStudy.notes || procedure.notes || "";
          study.doctorName =
            legacyStudy.updatedBy?.name || study.doctorName;
        } else {
          study.notes = procedure.notes || "";
        }
        return;
      }

      const legacyStudy = parseCaseStudyData(
        procedure.notes,
        procedure.longdesc,
      );
      study.date = legacyStudy.date || study.date;
      study.notes =
        legacyStudy.notes ||
        procedure.longdesc ||
        procedure.notes ||
        study.notes;
      study.doctorName =
        legacyStudy.updatedBy?.name ||
        study.doctorName;
    });

  return Array.from(groupedStudies.values())
    .map((study) => ({
      ...study,
      doctorName:
        doctorNamesById[String(study.doctorId)] ||
        study.doctorName ||
        "Not available",
    }))
    .sort(
      (first, second) =>
        new Date(second.date || 0) -
        new Date(first.date || 0),
    );
};

const CASE_RECORD_LAYOUTS = {
  nurse: {
    title: "Nursing Initial Assessment",
    sections: [
      {
        title: "Vitals",
        fields: [
          ["BP", "BP"],
          ["Saturation", "Saturation"],
          ["Temperature", "Temperature"],
          ["Height", "Height"],
          ["Pulse", "Pulse"],
          ["Weight", "Weight"],
          ["Respiratory Rate", "Respiratory Rate"],
          ["GRBS", "GRBS"],
        ],
      },
      {
        title: "Examination",
        fields: [
          ["Level of Consciousness", "Level of Consciousness", true],
          ["Respiratory Status", "Respiratory Status", true],
          ["Nurse Chief Complaint", "Present Chief Complaint", true],
          ["Skin Integrity", "Skin Integrity", true],
        ],
      },
      {
        title: "Medication and Care",
        fields: [
          ["Current Medications", "Current Medications", true],
          ["Investigation Ordered", "Investigation Ordered", true],
          ["Diet", "Diet"],
          ["Vulnerable Nurse", "Vulnerable"],
          ["Special Care", "Special Care Given", true],
        ],
      },
      {
        title: "Pain and Safety Assessment",
        fields: [
          ["Pain Score", "Pain Score"],
          ["Pressure Sores", "Pressure Sores"],
          ["Pressure Sores Description", "Pressure Sore Description", true],
          ["Restraints Used", "Restraints Used"],
          ["Restraint Description", "Restraint Description", true],
        ],
      },
      {
        title: "Additional Notes",
        fields: [
          ["Comment", "Comment", true],
          ["Follow Up Date For Vedamaayu", "Follow-up Date"],
        ],
      },
    ],
  },
  doctor: {
    title: "Doctor's Initial Assessment",
    sections: [
      {
        title: "History",
        fields: [
          ["Chief Complaint", "Chief Complaint", true],
          ["Present History", "Present History", true],
          ["Past History", "Past History", true],
          ["Personal History", "Personal History", true],
          ["Menstrual Details", "Menstrual Details", true],
          ["Appetite", "Appetite"],
          ["Micturition", "Micturition"],
          ["Bowel", "Bowel"],
          ["Sleep", "Sleep"],
          ["Family History", "Family History", true],
        ],
      },
      {
        title: "General and Systemic Examination",
        fields: [
          ["General Systemic Examination", "Examination", true],
          ["Doctor Temp", "Temperature"],
          ["Doctor BP", "BP"],
          ["Doctor Pulse", "Pulse"],
          ["Doctor Height", "Height"],
          ["Doctor Weight", "Weight"],
        ],
      },
      {
        title: "Clinical Assessment",
        fields: [
          ["Allergies Adverse Reaction", "Allergies / Adverse Reaction"],
          ["Allergies Adverse Reaction Details", "Allergy Details", true],
          ["Vulnerable Patient Doctor", "Vulnerable Patient"],
          ["Vulnerable Patient Details", "Vulnerability Details", true],
          ["Lab Investigation", "Lab Investigation", true],
          ["Treatment History", "Treatment History", true],
          ["Diagnosis", "Diagnosis", true],
          ["Doctor Notes", "Doctor Notes", true],
        ],
      },
      {
        title: "Additional Notes",
        fields: [
          ["Comment", "Comment", true],
          ["Follow Up Date For Vedamaayu", "Follow-up Date"],
        ],
      },
    ],
  },
};

const NURSE_ONLY_CASE_RECORD_FIELDS = new Set(
  CASE_RECORD_LAYOUTS.nurse.sections
    .flatMap((section) => section.fields.map(([field]) => field))
    .filter(
      (field) =>
        !CASE_RECORD_LAYOUTS.doctor.sections
          .flatMap((section) => section.fields.map(([doctorField]) => doctorField))
          .includes(field),
    ),
);

// Older visits were saved before `caseRecordSubgroup` was added.  Some of
// those rows also have title-cased values (for example, "Doctor Notes") in
// `subgroup`.  Keep the timeline grouping independent of that storage detail
// so a selected previous visit renders one card per note type, just like the
// current visit.
const getCaseRecordType = (procedure) => {
  const subgroup = String(
    procedure?.caseRecordSubgroup || procedure?.subgroup || "",
  )
    .trim()
    .toLowerCase();

  if (subgroup.includes("nurse")) return "nurse";
  if (subgroup.includes("doctor")) return "doctor";
  if (NURSE_ONLY_CASE_RECORD_FIELDS.has(procedure?.claSS)) return "nurse";

  // Case-record rows created by the original form did not store a subgroup.
  // They are doctor's assessment fields, so preserve their existing display
  // and aggregate them as a doctor's note.
  return String(procedure?.groupname || "").toLowerCase() ===
    String(CASERECORD).toLowerCase()
    ? "doctor"
    : "";
};

const DISCHARGE_SUMMARY_LAYOUT = {
  title: "Discharge Summary",
  sections: [
    {
      title: "Clinical Summary",
      fields: [
        ["Clinical investigations", "Clinical Investigations", true],
        ["Course of treatment in hospital", "Course of Treatment in Hospital", true],
        ["Advice on discharge", "Advice on Discharge", true],
      ],
    },
    {
      title: "Discharge Details",
      fields: [
        ["dischargedt", "Discharged At"],
        ["Discharge Date", "Discharge Date"],
        ["Follow Up Date", "Follow-up Date"],
      ],
    },
  ],
};

const getLatestPrescriptionDate = (prescriptions = []) => {
  const validDates = prescriptions
    .flatMap((item) => [item, ...(item.combinedEhrPrescriptions || [])])
    .map((item) => item?.cdt || item?.udt)
    .filter((value) => value && !Number.isNaN(new Date(value).getTime()));

  return validDates.reduce((latest, current) => {
    if (!latest) return current;
    return new Date(current).getTime() > new Date(latest).getTime()
      ? current
      : latest;
  }, null);
};

function ProcedureListing(props) {
  const org = useOrganization();
  const getRole = () => {
    const storedRole = localStorage.getItem("role");
    if (!storedRole) return null;

    try {
      return JSON.parse(storedRole);
    } catch (error) {
      return storedRole;
    }
  };
  const role = getRole();
  const roles = Array.isArray(role) ? role : [role];
  const isNurse = roles
    .filter(Boolean)
    .some((item) => String(item).trim().toLowerCase() === ROLE_KEYS.Nurse.toLowerCase());
  const isDoctorLogin = roles
    .filter(Boolean)
    .some(
      (item) =>
        String(item).trim().toLowerCase() === ROLE_KEYS.Doctor.toLowerCase(),
    );
  const receptionAdminRoles = new Set([
    "admin",
    ROLE_KEYS.RegistrationDesk.toLowerCase(),
    ROLE_KEYS.FrontDesk.toLowerCase(),
  ]);

  const isReceptionOrAdmin = roles
    .filter(Boolean)
    .some((item) =>
      receptionAdminRoles.has(String(item).trim().toLowerCase()),
    );
  const [active, setActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showOptions, setShowOptions] = useState(true);
  //const[patientData, setPatientData] = useState();
  const [patientProcedureList, setPatientProcedureList] = useState();
  const [patientresp, setPatientResp] = useState();
  const [procedruelistCopy, setprocedruelistCopy] = useState();
  const [procedureNotes, setProcedureNotes] = useState([]);
  const [showPatientBasic, setShowPatientBasic] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState({});
  //remove below state variable might not be needed pls check later
  const [selectedPatientInfo, setSelectedPatientInfo] = useState({});
  const [renderPrescription, setRenderPrescription] = useState(false);
  const [selectedDatePres, setSelectedDatePres] = useState({});
  const [showDischargeSummary, setShowDischargeSummary] = useState();
  const [dischargeSummary, setDischargeSummary] = useState([]);
  const [showMarkForDel, setShowMarkForDel] = useState(true);
  const [selectedProcedure, setselectedProcedure] = useState();
  const selectedCaseRecordSubgroup = getCaseRecordType(selectedProcedure);
  const shouldShowNurseCaseRecord =
    selectedCaseRecordSubgroup === "nurse" ||
    (!selectedCaseRecordSubgroup && isNurse);
  const isSelectedCaseRecordReadOnly =
    props.readOnly ||
    (selectedCaseRecordSubgroup === "nurse"
      ? !isNurse
      : selectedCaseRecordSubgroup === "doctor"
        ? isNurse
        : false);
  const [deleteProcedure, setDeleteProcedure] = useState();
  const [selectMarkForDel, setSelectMarkForDel] = useState({
    patientId: "",
    visitId: "",
    id: "",
    markForDel: "",
  });

  const [pateintdetails, setPatientDetails] = useState({
    name: "",
    visitDate: "",
  });
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const [showReviewModel, setShowReviewModel] = useState(false);
  const [showComposition, setShowComposition] = useState(false);
  const [showCaseStudy, setShowCaseStudy] = useState(false);
  const [painAssessmentForm, setPainAssessmentForm] = useState(null);
  const [painAssessmentPrint, setPainAssessmentPrint] = useState(null);
  const [completingPainAssessment, setCompletingPainAssessment] = useState("");
  const [compositeUltrasound, setCompositeUltrasound] = useState(false);
  const [templateId, setTemplateId] = useState();
  const [flag, setFlag] = useState();
  const [uploadedImages, setUploadedImages] = useState([]);
  const [getUploadImages, setGetUploadImages] = useState([]);
  const [dischargesummary, setDischargeSummaryData] = useState({
    preparedBy: "",
    approver: "",
    patientId: "",
    visitId: "",
    notes: "",
    groupname: "",
    notes: "",
    subgroup: "",
    type: "",
    id: "",
  });
  const [compositionPreviewValue, setCompositionPreviewValue] = useState({
    brandName: "",
    icdName: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    uploads: false,
    discharge: false,
    templates: false,
    services: false,
    date: false,
    prescriptions: false,
  });
  const [reloadData, setReloadData] = useState(false);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  //const [allOrFilteredProcedureList, setAllOrFilteredProcedureList] = useState();
  const [filterVisitDates, setFilterVisitDates] = useState({
    // '2022-07-25','2022-07-26','2022-07-27','2022-07-28','2022-07-29'
  });
  const [showFilerVisitDate, setshowFilerVisitDate] = useState(false);
  //const [procedureDate, setPrcedureDate] = useState();
  let procedureDate = "";
  const [selectedDate, setSelecetdDate] = useState(new Date());
  const [reloadModal, setReloadModal] = useState(false);
  const [state, setState] = useState({ open: false });
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });

  const allVisitdates = useSelector(
    (state) => state.patientDetailsState.patientBasic,
  );
  const [allVisitdate, setallVisitdate] = useState([]);
  //const eprescription = useSelector(state => state.patientDetailsState.ePresc);
  const [eprescription, seteprescription] = useState();
  const [print, setPrint] = useState(false);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selecetdCount, setselecetdCount] = useState(0);

  const [proceduresToPrint, setproceduresToPrint] = useState();
  const [pData, setPData] = useState([]);

  const [markCompleteModal, setmarkCompleteModal] = useState(false);

  const [showpdfscreen, setpdfscreen] = useState(false);
  const [dischargepdfscreen, setdischargepdfscreen] = useState(false);

  const [showService, setShowService] = useState(false);
  const [caseRecordModal, setCaseRecordModal] = useState(false);
  const patientEhrid = useSelector((state) => state.patientDetailsState.ehrid);
  const [serviceDetails, setServiceDetails] = useState({});
  const selectedID = useSelector(
    (state) => state.patientDetailsState.selectedPatientId,
  );
  const [showConsutant, setShowConsultant] = useState(false);
  const [consultantDetails, setconsultantDetails] = useState({});
  const [dischargePrint, setDischargePrint] = useState(false);
  const [directDischargePrint, setDirectDischargePrint] = useState(null);
  const [labReportPrintStatus, setLabReportPrintStatus] = useState(false);
  const [radiologyReportPrintStatus, setRadiologyReportPrintStatus] =
    useState(false);
  const [docDetail, setDocDetail] = useState({});
  const [epriscTemplate, setepriscTemplate] = useState({});
  const [onmodal, setOnModal] = useState(false);
  const [lab_admin, setLab_admin] = useState(props.lab_admin);
  const [x_ray, setX_ray] = useState(props.x_ray);
  const [radiology, setRadiology] = useState(props.radiology);
  const [doctorList, setDoctorList] = useState([]);
  const [doctorInformation, setDoctorInformation] = useState({});
  const [gvid, setGvid] = useState(JSON.parse(localStorage.getItem("id")));
  const [printPreviewType, setPrintPreviewType] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedTests, setSelectedTests] = useState("");
  const [noteOptions, setNoteOptions] = useState([]);
  const [selectedNotes, setSelectedNotes] = useState([]);
  const [prescData, setPrescData] = useState(null);

  useEffect(() => {
    dispatch(
      doctorActions.getDoctorList({}, (response) => {
        if (Array.isArray(response)) {
          setDoctorList(response);
        }
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    console.log(
      "Data in the chat ...: ",
      props,
      props.selectedPatientInfo.person,
      selectedDate,
      appliedFilters,
      allVisitdates,
    );
    // getDoctorsList();
    setDocDetail(props.selectedPatientInfo.person);
    setSelecetdDate("");
    if (props.selectedPatientInfo.id != selectedID) {
      dispatch(
        patientActions.setSelectedPatientId(props.selectedPatientInfo.id),
      );
      setShowReviewModel(false);
      setShowComposition(false);
      setShowDischargeSummary(false);
      setShowService(false);
      setShowOptions(true);
      setselecetdCount(0);
      setPrint(false);
      setpdfscreen(false);
    }
    console.log("listing procedures", props);
    let patientId = props.selectedPatientInfo.id;
    let visitId = props.selectedPatientInfo.visit.id;
    let patientDetails = [];
    let pOpt = {};
    pOpt["patientId"] = patientId;
    pOpt["visitId"] = visitId;
    patientDetails.push(pOpt);
    setPData([...patientDetails]);
    // props.showPatientEditForm
    procedruelist(patientId, visitId);

    setShowFilterOptions(false);
    console.log(
      "selectedDatePres",
      props,
      props.selectedPatientInfo.procedureslist,
    );
    let patient;
    patient = props.selectedPatientInfo;
    console.log("patient selectedDatePres", props.selectedPatientInfo);
    //setPatientData(patientProcedureList);
    if (
      props &&
      props.selectedPatientInfo &&
      props.selectedPatientInfo.procedureslist
    ) {
      for (let prescription of props.selectedPatientInfo.procedureslist) {
        console.log("prescription notes update : ", prescription.notes);
      }
    }
    console.log("patientProcedureList : ", patientProcedureList);
    if (props.selectedPatientInfo.visit.status === "close") {
      setSelecetdDate(props.selectedPatientInfo.visit.visitDate);
      procedurelistByVisitDate(props.selectedPatientInfo.visit.id);
    }
    setTimeout(() => {
      var element = document.getElementById("patient-pres");
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
    }, 500);
  }, [props]);

  const procedurelistByVisitDate = (data) => {
    console.log("patientProcedureList:", patientProcedureList);
    filterVisitDates.visitId = data;
    filterVisitDates.patientId = props.selectedPatientInfo.id;
    dispatch(
      patientActions.getPatientProcedureByLastVisitDate(
        filterVisitDates,
        (resCb) => {
          console.log("Visit data from API:", resCb.patientresp.visit);
          console.log("Visit type:", resCb.patientresp.visit?.type);
          if (
            resCb &&
            resCb.patientresp &&
            Object.keys(resCb.patientresp).length > 0
          ) {
            // setShowPatientProcedure(true)
            console.log("getPatientProcedureByLastVisitDate :", resCb);

            resCb.patientresp.procedureslist.forEach((element) => {
              element["print"] = false;
            });
            setPatientProcedureList({ ...resCb.patientresp });
            setprocedruelistCopy({ ...resCb.patientresp });
            console.log(
              "getPatientProcedureByLastVisitDate1 :",
              patientProcedureList,
            );
            // setAllOrFilteredProcedureList(resCb.patientresp)
            // setFilterVisitDates(resCb.patientresp)
            // console.log("PatientProcedureByLastVisitDate :", allOrFilteredProcedureList)
          }
        },
      ),
    );
  };

  const markForDel = (presc, event) => {
    console.log("event in presc.markForDel", event);
    var ServerResVal = ServerRes;
    console.log("delete proceudre", deleteProcedure);
    console.log("presc.markForDel", presc);
    const proceduresToDelete =
      deleteProcedure?.combinedEhrPrescriptions?.length > 0
        ? deleteProcedure.combinedEhrPrescriptions
        : [deleteProcedure];
    let completedDeletes = 0;
    let deleteFailed = false;

    proceduresToDelete.forEach((procedure) => {
      const markForDel = {
        patientId: procedure.patientId,
        visitId: procedure.visitId,
        id: procedure.id,
        markForDel: true,
      };
      procedure.markForDel = true;
      console.log("presc.markForDel3", markForDel);

      dispatch(
        patientActions.markForDel(markForDel, (resCb) => {
          console.log("deleted procedure Response ", resCb);
          if (!resCb?.successMessages) {
            deleteFailed = true;
          }

          completedDeletes += 1;
          if (completedDeletes !== proceduresToDelete.length) {
            return;
          }

          if (deleteFailed) {
            ServerResVal.error = "Failed to delete procedure";
          } else {
            ServerResVal.success = "Procedure details deleted successfully";
            const productList = proceduresToDelete
              .filter((procedure) => procedure.templateId === EPRESCRIPTION)
              .map((procedure) => ({
                product: String(procedure.productId || "").trim(),
                units: Number(procedure.quantity),
              }))
              .filter((product) => product.product && product.units > 0);
            const cartNo = String(props.selectedPatientInfo?.phno ?? "").trim();
            if (cartNo && productList.length > 0) {
              dispatch(
                ehrActions.deletePrescriptionFromErp(
                  { cartNo, productList },
                  (erpResponse) => {
                    if (erpResponse?.warningMessages?.length) {
                      console.warn(erpResponse.warningMessages[0]);
                    } else {
                      console.log("ERP prescription delete response:", erpResponse);
                    }
                  },
                ),
              );
            }
          }
          setOpenDeleteModal(false);
          setServerRes({ ...ServerResVal });
          procedruelist(presc.patientId, presc.visitId);
          setReloadData(true);
          setTimeout(() => {
            closeAlert();
          }, 5000);
          setShowMarkForDel(false);
        }),
      );
    });
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  const procedruelist = (patientId, visitId) => {
    let type = "showAllVisits";
    setallVisitdate([]);
    dispatch(
      patientActions.getPatientProcedureInfo(
        patientId,
        visitId,
        type,
        (resCb) => {
          if (resCb) {
            // setShowPatientProcedure(true)
            console.log(
              "DiagetPatientProcedureInfo response in patient presc layout :",
              resCb,
            );
            if (resCb.patientresp.procedureslist != null) {
              resCb.patientresp.procedureslist.forEach((element) => {
                element["print"] = false;
              });
              resCb.patientresp.procedureslist = resCb.patientresp.procedureslist.filter(
                (item) =>
                  item.claSS !== "session_id" &&
                  item.claSS !== "patient title" &&
                  !isDischargeSummaryComposition(item)
              );
            }
            console.log(
              "procedurelist with actions:",
              resCb.patientresp.procedureslist,
            );
            let uploads = resCb.patientresp.uploadslist
              ? resCb.patientresp.uploadslist.filter(
                (item) => item.imgurl != null,
              )
              : [];
            setDischargeSummary(resCb.patientresp);
            setUploadedImages([...uploads]);
            let procedureResponse = resCb.patientresp.procedureslist;
            procedureResponse.map((procedure) => {
              //  let date = new Date(procedure.cdt);
              //  const hour = date.getHours();
              //  const minute = date.getMinutes();
              //  procedure.udt = `${hour}:${minute < 10 ? '0' + minute : minute}`;
              procedure["action"] = false;
            });
            //  const uniqueValues = {};
            //   const filteredData = resCb.patientresp.procedureslist.filter((item) => {
            //     if (!uniqueValues[item.groupid]) {
            //       uniqueValues[item.groupid] = true;
            //       return true;
            //     }
            //     return false;
            //   });

            setPatientProcedureList(resCb.patientresp);
            setPatientResp(resCb.patientresp);

            let notes = resCb.patientresp.procedureslist.filter(
              (proc) => proc.notes && !proc.groupname && !proc.markForDel,
            );
            setProcedureNotes([...notes]);
            console.log("notes extracted:", notes);
            setprocedruelistCopy(resCb.patientresp);
            console.log(
              "selectedPatientInfo patient layout :",
              patientProcedureList,
            );
            dispatch(patientActions.tokenList(resCb.patientresp));
            setShowPatientBasic(false);
            setReloadModal(true);
          }
        },
      ),
    );
  };

  const formatUdt = (cdt) => {
    let date = new Date(cdt);
    const hour = date.getHours();
    const minute = date.getMinutes();
    let udt = `${hour}:${minute < 10 ? "0" + minute : minute}`;
    return udt;
  };
  const showImage = (data) => {
    console.log("showImage", data);

    // Filter only items where imgurl is present and not null/undefined
    let uploadslist = patientProcedureList.uploadslist.filter(
      (img) => !!img.imgurl,
    );

    setGetUploadImages([...uploadslist]);
    setData(uploadslist.length - 1);

    console.log(
      "Filtered uploadslist: ",
      uploadslist,
      "Length:",
      uploadslist.length,
    );

    setShowModal(true);
  };

  const closeModal = (event) => {
    setShowModal(false);
  };

  const showAllOptions = (event) => {
    console.log("message obtained:", event);
    //setShowOptions(!showOptions);
    if (patientProcedureList.id) {
      procedruelist(patientProcedureList.id, patientProcedureList.visit.id);
    }
    if (event && event.success != "  ") {
      setMessageStrip(event);
    }
  };
  const setcloseAttachAction = (event) => {
    // procedruelist(patientProcedureList.id)

    setcloseAttachAction(!setcloseAttachAction);
    // setShowOptions(!showOptions)
    // props.openAttachment()
    // useEffect
  };
  const getFormattedDate = (date) => {
    procedureDate = date;
    const reqdate = new Date(date);
    // const formatteddate = day + "/" + month + "/" + year + "   " +  hour+ ":" + min;
    let formatteddate = format(reqdate, "MMM dd yyyy' 'HH:mm");
    return formatteddate;
  };

  const getFormateDate = (date) => {
    procedureDate = date;
    const reqdate = new Date(date);
    // const formatteddate = day + "/" + month + "/" + year + "   " +  hour+ ":" + min;
    let formatedate = format(reqdate, "MMM dd yyyy");
    return formatedate;
  };

  const zoomReviewModalClose = (event) => {
    setShowReviewModel(false);
    if (event) {
      setMessageStrip(event);
    }
    procedruelist(patientProcedureList.id, patientProcedureList.visit.id);
  };

  const zoomReviewModal = (presc, event) => {
    if (
      isDoctorLogin &&
      isPainAssessmentProcedure(presc) &&
      presc?.subgroup
    ) {
      setShowCaseStudy(false);
      setPainAssessmentForm({
        patientId: presc.patientId,
        visitId: presc.visitId,
        subgroup: presc.subgroup,
        mode: "edit",
      });
      return;
    }

    // Patient Case Study opens its stacked history screen, not Case Record.
    if (presc?.groupname === PROCEDURE_GROUPNAME_PATIENT_CASE_STUDY) {
      setCaseRecordModal(false);
      setselectedProcedure(undefined);
      setShowCaseStudy(true);
      return;
    }
    console.log("presc :", presc);
    let notes = [];
    notes.push(presc);
    dispatch(patientActions.setSelectedNotes(notes));

    if (presc.subgroup == RADIOLOGYREPORT) {
      serviceListModal(presc);
    } else {
      // ✅ Grouped EHR — open TemplatePreview with all medicines stacked
      if (
        presc.combinedEhrPrescriptions &&
        presc.combinedEhrPrescriptions.length > 0
      ) {
        setShowComposition(true);
        setFlag("editComposition");
        setTemplateId(presc.combinedEhrPrescriptions[0].templateId);
        setselectedProcedure(presc); // ✅ pass full grouped presc
        return;
      }

      if (presc.compositionId && presc.compositionId != null) {
        // EHR org - normal flow
        setShowComposition(true);
        setFlag("editComposition");
        setTemplateId(presc.compositionId);
        setselectedProcedure(presc);
      } else if (
        !presc.compositionId &&
        (presc.templateId == DFollowupNote || presc.templateId == CFollowupNote)
      ) {
        setShowComposition(true);
        setFlag("editComposition");
        setTemplateId(presc.templateId);
        setselectedProcedure(presc);
      } else if (!presc.compositionId && presc.templateId && presc.groupname === "EHR") {
        // ✅ Non-EHR org (Vedamaayu) — notes has full JSON body
        setShowComposition(true);
        setFlag("editComposition");
        setTemplateId(presc.templateId);
        setselectedProcedure(presc);
      } else if (!presc.compositionId) {
        let procedure = {
          patientId: presc.patientId,
          groupid: presc.groupid,
          visitId: presc.visitId,
          tags: presc.tags,
        };
        reviewNotes(procedure);
      }
    }
  };
  const caseRecordView = (presc) => {
    setShowCaseStudy(false);
    console.log("presc :", presc);
    let notes = [];
    notes.push(presc);
    dispatch(patientActions.setSelectedNotes(notes));
    setselectedProcedure(presc);
    console.log("presc2 :", presc);
    let procedure = {
      patientId: presc.patientId,
      groupid: presc.groupid,
      visitId: presc.visitId,
      tags: presc.tags,
    };
    console.log("procedure :", procedure);
    console.log("props :", procedure.groupId, patientProcedureList);
    setPatientProcedureList(patientresp);
    setCaseRecordModal(true);
  };

  const listTemplates = (data) => {
    // let data = {}
    dispatch(
      doctorActions.listTemplates(data, (resCb) => {
        if (resCb) {
          console.log("listTemplates API Response:", resCb);
        }
      }),
    );
  };
  const zoomMeetingReview = useSelector(
    (state) => state.doctorDetailsState.zoomReview,
  );
  const reviewNotes = (data) => {
    // let data = {}
    dispatch(
      doctorActions.reviewNotes(data, (resCb) => {
        if (resCb) {
          console.log("reviewZoomNotes API Response:", resCb);

          // dispatch(patientActions.setSelectedNotes(notes));
          setShowReviewModel(true);
        }
      }),
    );
  };

  const dischargemodal = (presc, event) => {
    console.log("dischargemodal :", presc, "event : ", event);
    let url = "/DischargeSummary/" + presc.patientId + "/" + presc.visitId;
    window.open(url, "_blank");
    // let procedure = { patientId: presc.patientId, groupname: presc.groupname, visitId: presc.visitId }
    // console.log("procedure", procedure);
    //  console.log("patientProcedureList : ",patientProcedureList);

    // let localDisSum = {};
    // localDisSum['id'] = presc.id
    // localDisSum['preparedBy'] = presc.preparedBy;
    // localDisSum['approver'] = presc.approver;
    // localDisSum['patientId'] = presc.patientId;
    // localDisSum['visitId'] = presc.visitId;
    // localDisSum['groupname'] = presc.groupname;
    // localDisSum['notes'] = presc.notes;
    // localDisSum['type'] = presc.type;
    // localDisSum['subgroup'] = presc.subgroup;
    // setDischargeSummaryData(localDisSum);

    // console.log("discharge Summary -", localDisSum);
    // setShowDischargeSummary(true)
  };

  useEffect(() => {
    console.log("inside discharge summary--", props);
    // patientSummaryClick(props.patientData)
  }, [props.dischargesummary]);


  /*useEffect(() => {
    const handleFocus = () => {
      const patientId = props.selectedPatientInfo.id;
      const visitId = props.selectedPatientInfo.visit.id;
      if (patientId && visitId) {
        procedruelist(patientId, visitId);
      }
    };

    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [props.selectedPatientInfo]); */

  const closeDischargeSummaryModal = (event) => {
    setShowDischargeSummary(false);
    console.log("patientProcedureList:", patientProcedureList);
    procedruelist(patientProcedureList.id, patientProcedureList.visit.id);
    if (event) {
      setMessageStrip(event);
    }
  };

  const backToUserList = () => {
    document.getElementById("user-list").classList.remove("mobile-view");
    document.getElementById("user-info").classList.remove("mobile-view");
  };

  const applyFilter = (name, value) => {
    setActive(!active);
    var filters = appliedFilters;
    // if(name != 'date')
    filters[name] = !value;
    console.log("filters:", filters);
    setAppliedFilters(filters);

    // If none of the filters applied return original object
    if (Object.values(appliedFilters).every((item) => item === false)) {
      setPatientProcedureList({ ...procedruelistCopy });
      setReloadData(!reloadData);
      return;
    }

    let filteredData = [];
    procedruelistCopy.procedureslist.map((value, index) => {
      console.log("procedurelistcopy", value);
      if (appliedFilters.uploads) {
        if (value.uploadid > 0) {
          filteredData.push(procedruelistCopy.procedureslist[index]);
        }
      }

      if (appliedFilters.discharge) {
        if (value.groupname == "Discharge Summary") {
          filteredData.push(procedruelistCopy.procedureslist[index]);
        }
      }

      if (appliedFilters.services) {
        if (value.categoryServiceId > 0) {
          filteredData.push(procedruelistCopy.procedureslist[index]);
        }
      }
      if (appliedFilters.prescriptions) {
        if (
          value.groupname == "EHR" &&
          value.templateId == "ePrescription (epSoS/Contsys)"
        ) {
          filteredData.push(procedruelistCopy.procedureslist[index]);
        }
      }
      if (appliedFilters.templates) {
        // console.log("appliedFilters",appliedFilters);
        console.log("groupname", value.groupname);
        if (value.groupname == "EHR") {
          filteredData.push(procedruelistCopy.procedureslist[index]);
        }
      }
    });
    console.log("filteredlist:", filteredData);
    // setAllOrFilteredProcedureList({procedureslist:filteredData});
    // console.log("allOrFilteredProcedureList:",allOrFilteredProcedureList);
    // setPatientProcedureList({procedureslist:filteredData});
    setPatientProcedureList({ ...{ procedureslist: filteredData } });
    console.log("patientProcedureList:", patientProcedureList);

    setReloadData(!reloadData);
  };

  const toggleFilterOptions = () => {
    setShowFilterOptions(!showFilterOptions);
    handleallVisitdates();
  };

  const handleallVisitdates = () => {
    console.log("handleallVisitdates", allVisitdates);
    let visitLoop = [];
    if (allVisitdates.visitList) {
      allVisitdates.visitList.forEach((lastVisited) => {
        if (lastVisited.internalStatus !== "NotVisited") {
          // allVisitdate.push(lastVisited);
          visitLoop.push(lastVisited);
        }
      });
      setallVisitdate(visitLoop);
    }
  };

  const handleChange = (event, value) => {
    //appliedFilters.date = event.target.value ? true : false;
    //selectedDate = event.target.value ;

    console.log("event.target.value:", event.target.value);
    setSelecetdDate(event.target.value);
    if (event.target.value == "Select Visit Date") return;
    procedurelistByVisitDate(event.target.value);
    console.log(" appliedFilters.date:", appliedFilters.date);
    //applyFilter("date",value);
  };

  const expandOptions = (e) => {
    console.log("expnaded options:");
  };

  const toggle = (i, presc) => {
    console.log("i", i);
    console.log("presc", presc);
    console.log("patientProcedureList", patientProcedureList);
    let list = patientProcedureList;
    if (presc) {
      list.procedureslist[i].action = !list.procedureslist[i].action;
      // list.procedureslist.forEach(element => {
      //   if(element.id == presc.id){
      //     console.log("slected procedure is equal");

      //       element["action"] = true;

      //   }
      // else {
      //   element["action"] = false;
      // }
      // });
      console.log("list", list);

      setPatientProcedureList({ ...list });
    }
    // setState(prevState => {
    //   return { open: !prevState.open };
    // });
  };

  const deleteNotes = (event) => {
    console.log("deleteNotes:", event);
    if (isDeleteProtectedProcedure(event.presc)) return;
    setDeleteProcedure(event.presc);
    markForDel(event.presc, event.e);
  };

  const isDeleteProtectedProcedure = (procedure) => {
    const groupName = String(procedure?.groupname || "").toLowerCase();
    const subgroup = String(
      procedure?.caseRecordSubgroup || procedure?.subgroup || "",
    ).toLowerCase();

    return (
      isDiagnosisOrVitalSignsProcedure(procedure) ||
      groupName === String(DISCHARGESUMMARY).toLowerCase() ||
      String(procedure?.templateId || "").toLowerCase() ===
        String(DISCHARGESUMMARY).toLowerCase() ||
      (groupName === String(CASERECORD).toLowerCase() &&
        (subgroup === "doctor" || subgroup === "nurse"))
    );
  };

  const confirmDelete = (val, e, procedure) => {
    //e.preventDefault();
    if (isDeleteProtectedProcedure(procedure)) {
      e?.preventDefault();
      return;
    }
    if (
      (patientProcedureList.visit?.internalStatus &&
        patientProcedureList.visit.internalStatus === "MOVED_TO_BILLING") ||
      patientProcedureList.visit.internalStatus === "forceclose" ||
      patientProcedureList.visit.internalStatus === "INVOICE_GENERATED" ||
      patientProcedureList.visit.internalStatus === "BILL_CLEARED"
    ) {
      // Return true or perform some action
      ModalOpen();
    } else {
      console.log("procedure conform delete:", procedure);
      console.log("conform delete:", val);
      setDeleteProcedure(procedure);
      setOpenDeleteModal(val);
      e.preventDefault();
    }
  };

  const ModalOpen = () => {
    console.log("move to bill method:");
    setOnModal(true);
  };

  const closeDelete = () => {
    setOnModal(!onmodal);
    //props.onModalClose();
  };

  const takePrint = (e, pres) => {
    if (isDiagnosisOrVitalSignsProcedure(pres)) {
      e?.preventDefault();
      return;
    }

    setPrint(true);
    console.log("pres: ", pres);
    console.log("preescptionjcujc", pres.compositionId);
    // setepriscTemplate(pres.compositionId);
    //set checkbox of selected item to true
    setTimeout(() => {
      let elm = document.getElementById(pres.id);
      console.log(elm);
      if (elm) elm.checked = true;
    }, 500);

    let count = selecetdCount;
    count++;
    setselecetdCount(count);
    updateProcedureList(pres, true);

    if (pres.subgroup === RADIOLOGYREPORT) {
      setTemplateId(pres.templateId);
      setRadiologyReportPrintStatus(true);
    } else {
      setRadiologyReportPrintStatus(false);
      // ✅ For non-EHR org — compositionId is null, use templateId directly
      if (pres.compositionId) {
        // EHR org — fetch from EHRbase using compositionId
        updateEprescription(pres.compositionId, pres.templateId);
      } else if (pres.groupname === "EHR" && pres.templateId && pres.notes) {
        // Non-EHR org — parse notes JSON directly
        updateEprescription(null, pres.templateId);
      }
    }

    console.log("pres.compositionId:", pres.compositionId);
    console.log("pres.subgroup:", pres.subgroup);
    console.log("pres.templateId:", pres.templateId);
  };

  const takeCaseRecordPrint = (event, presc) => {
    event?.preventDefault();
    event?.stopPropagation();

    const records = presc.caseRecordGroup?.length
      ? presc.caseRecordGroup
      : [presc];
    const notes = records.reduce((result, record) => {
      if (record?.claSS) {
        result[record.claSS] = record.notes ?? "";
      }
      return result;
    }, {});
    // The procedure API response does not include the assigned person from the
    // patient-list response. Preserve that information for print headers while
    // still using the latest patient/visit details returned with procedures.
    const patientData = {
      ...props.selectedPatientInfo,
      ...patientProcedureList,
      visit: {
        ...props.selectedPatientInfo?.visit,
        ...patientProcedureList?.visit,
      },
      person:
        patientProcedureList?.person || props.selectedPatientInfo?.person,
      doctor:
        patientProcedureList?.doctor || props.selectedPatientInfo?.doctor,
      doctorName:
        patientProcedureList?.doctorName ||
        props.selectedPatientInfo?.doctorName,
    };
    const assessmentCreatedDate =
      records.find((record) => record?.cdt)?.cdt ||
      records.find((record) => record?.udt)?.udt;
    const recordType = getCaseRecordType(presc) || "doctor";

    if (recordType === "nurse") {
      openNursePrint(notes, patientData);
      return;
    }
    openDoctorPrint(notes, patientData, {
      assessmentDate: assessmentCreatedDate,
    });
  };

  const takeDirectDischargePrint = (event, presc) => {
    event?.preventDefault();
    event?.stopPropagation();

    const cardRecords = presc.dischargeSummaryGroup?.length
      ? presc.dischargeSummaryGroup
      : [presc];
    const buildSummary = (records, response) => records.reduce((result, record) => {
      if (!record?.claSS) return result;

      if (record.claSS === "Advice on discharge") {
        try {
          const medicines = JSON.parse(record.notes);
          result[record.claSS] = Array.isArray(medicines) ? medicines : [];
        } catch (error) {
          result[record.claSS] = [];
        }
      } else {
        result[record.claSS] = record.notes ?? "";
      }
      return result;
    }, response?.visit?.dischargeDate
      ? { dischargedt: response.visit.dischargeDate }
      : {});

    const printResponse = (response, availableDoctors = []) => {
      const records = response?.procedureList?.filter(
        (record) =>
          record?.groupname === DISCHARGESUMMARY && !record?.markForDel,
      );
      const summary = buildSummary(
        records?.length ? records : cardRecords,
        response,
      );
      const assignedDoctorIds = new Set(
        (response?.vaList || [])
          .filter((assignment) => assignment?.targetid)
          .map((assignment) => String(assignment.targetid)),
      );
      const treatingDoctors = availableDoctors
        .filter((doctor) =>
          assignedDoctorIds.has(String(doctor?.personId)),
        )
        .map((doctor) =>
          [
            `${doctor?.displaytitle || ""} ${doctor?.first_name || ""} ${
              doctor?.last_name || ""
            }`.trim(),
            doctor?.department ? `Dep of ${doctor.department}` : "",
            doctor?.qualification
              ? `(${doctor.qualification})`
              : "",
          ]
            .filter(Boolean)
            .join(", "),
        );

      setDirectDischargePrint({
        summary,
        treatingDoctors,
        revisitDetails:
          response?.revisit?.scheduleddate ||
          summary["Follow Up Date"] ||
          summary["Follow-up Date"] ||
          null,
      });
    };

    const query = {
      patientId: presc.patientId,
      visitId: presc.visitId,
      groupname: DISCHARGESUMMARY,
      markForDel: false,
    };
    dispatch(
      patientActions.getDischargeSummary({}, query, (response) => {
        if (!response) {
          printResponse(null);
          return;
        }
        dispatch(
          doctorActions.getDoctorList({}, (availableDoctors) =>
            printResponse(
              response,
              Array.isArray(availableDoctors) ? availableDoctors : [],
            ),
          ),
        );
      }),
    );
  };

  const takeEdit = (event, presc) => {
    setselectedProcedure(presc);
    event.stopPropagation();

    let notesStr = presc?.notes || "";

    // Remove trailing 'report' (case-insensitive)
    notesStr = notesStr.replace(/\s*report\s*$/i, "");

    // Split by comma
    const notesArray = notesStr
      ? notesStr
        .split(",")
        .map((n) => n.trim())
        .filter(Boolean)
      : [];

    setNoteOptions(notesArray);
    setSelectedNotes(notesArray);
    setOpen(true);
  };

  const takeDischargePrint = (e, pres) => {
    setDischargePrint(true);
    console.log("takeDischargePrint", pres.compositionId);
    // setepriscTemplate(pres.compositionId);
    //set checkbox of selected item to true
    setTimeout(() => {
      let elm = document.getElementById(pres.id);
      console.log(elm);
      if (elm) elm.checked = true;
    }, 500);

    let count = selecetdCount;
    count++;
    setselecetdCount(count);
    updateProcedureList(pres, true);
    updateEprescription(pres.compositionId);
  };

  const cancelPrint = () => {
    patientProcedureList.procedureslist.forEach((item) => {
      item.print = false;
    });
    // setPatientProcedureList({
    //   ...{ procedureslist: patientProcedureList.procedureslist },
    // });
    setPrint(false);
    setselecetdCount(0);
    setproceduresToPrint([]);
  };

  const handleopenDeleteModal = () => {
    setOpenDeleteModal(!openDeleteModal);
  };

  const handlemarkCompleteModal = () => {
    setmarkCompleteModal(!markCompleteModal);
  };

  const selectForPrint = (val, pres) => {
    if (!isPrintable(pres)) return;
    console.log("val obtained:", val, pres);
    pres.print = val;

    let count = selecetdCount;
    if (val) {
      count++;
    } else {
      count--;
    }

    // Radiology reports check
    if (pres.subgroup === RADIOLOGYREPORT) {
      setRadiologyReportPrintStatus(true);
      setLabReportPrintStatus(false);
    }
    // Lab report check
    else if (pres.templateId && pres.subgroup?.includes("Lab_Report")) {
      setLabReportPrintStatus(true);
      setRadiologyReportPrintStatus(false);
    } else {
      // Neither radiology nor lab
      setLabReportPrintStatus(false);
      setRadiologyReportPrintStatus(false);
    }

    setselecetdCount(count);
    updateProcedureList(pres, val);
  };

  const updateProcedureList = (pres, val) => {
    patientProcedureList.procedureslist.forEach((item) => {
      if (item.id == pres.id) {
        item.print = val;
        // ✅ carry over the grouped prescriptions so Pdfprint can expand them
        if (pres.combinedEhrPrescriptions) {
          item.combinedEhrPrescriptions = pres.combinedEhrPrescriptions;
        }
      }
    });
    console.log("procedurelist with actions:", patientProcedureList.procedureslist);
    let filterList = patientProcedureList.procedureslist.filter(
      (item) => item.print == true,
    );
    setproceduresToPrint(filterList);
    getDoctorsList(filterList);
  };
  const getDoctorsList = (filterList, data) => {
    dispatch(
      doctorActions.getDoctorList(data, (resCb) => {
        if (resCb) {
          console.log("rescb from getdoctorlist: ", resCb);
          setDoctorList([...resCb]);
          const templateIds = filterList.map((item) => item.templateId);
          let latestDoctorIds = patientProcedureList.procedureslist
            .filter((pkg) =>
              templateIds[0]?.includes(pkg.packageService.name)
                ? pkg.refGvId
                : null,
            )
            .sort((a, b) => new Date(b.udt) - new Date(a.udt));
          let latestDoctorId = latestDoctorIds[0]?.refGvId;
          let doclist = resCb.filter((doc) => doc?.personId === latestDoctorId);

          setDoctorInformation({ ...doclist[0] });
          console.log(
            "latestDoctorId",
            filterList,
            templateIds,
            patientProcedureList.procedureslist,
            latestDoctorId,
            doclist,
          );
        }
      }),
    );
  };

  const openPdfModal = async (event, type) => {
    const selectedProcedures = proceduresToPrint || [];
    const selectedCaseStudyProcedures = selectedProcedures.filter(
      (procedure) =>
        procedure.groupname === PROCEDURE_GROUPNAME_PATIENT_CASE_STUDY,
    );
    const selectedOtherProcedures = selectedProcedures.filter(
      (procedure) =>
        procedure.groupname !== PROCEDURE_GROUPNAME_PATIENT_CASE_STUDY,
    );

    if (
      selectedCaseStudyProcedures.length > 0 &&
      selectedOtherProcedures.length > 0
    ) {
      setMessageStrip({
        error:
          "Please print Patient Case Studies separately from other records.",
      });
      return;
    }

    if (selectedCaseStudyProcedures.length > 0) {
      // Patient Case Studies use their dedicated A4 rich-text PDF.
      let printWindow;

      try {
        printWindow = openPatientCaseStudyPdfTab();
        const caseStudies = buildSelectedCaseStudies({
          allProcedures:
            patientProcedureList?.procedureslist || [],
          selectedProcedures: selectedCaseStudyProcedures,
          doctors: [
            ...(doctorList || []),
            props.selectedPatientInfo?.person,
          ].filter(Boolean),
        });
        const docDefinition = await generatePatientCaseStudyPdf({
          patientInfo: props.selectedPatientInfo,
          patientData: patientProcedureList,
          caseStudies,
        });

        renderPatientCaseStudyPdfTab(
          printWindow,
          docDefinition,
        );
        cancelPrint();
      } catch (error) {
        if (printWindow && !printWindow.closed) {
          printWindow.close();
        }
        console.error(
          "Unable to print Patient Case Studies:",
          error,
        );
        setMessageStrip({
          error: "Unable to print Patient Case Studies.",
        });
      }
      return;
    }

    if (print) {
      setpdfscreen(true);
      // setproceduresToPrint([]);
    }
    setTimeout(() => {
      setselecetdCount(0);
      setPrint(false);
      setpdfscreen(false);
      patientProcedureList.procedureslist.forEach((item) => {
        item.print = false;
      });
      //  setPatientProcedureList({...{ procedureslist: patientProcedureList.procedureslist}});
      // setPatientProcedureList({});
    }, 500);

    if (dischargePrint) {
      console.log("patientProcedureList:", dischargeSummary);
      setdischargepdfscreen(true);
    }

    setPrintPreviewType(type);
  };

  const closePdfModal = (event) => {
    if (print) {
      setpdfscreen(false);
    }
    if (dischargePrint) {
      setdischargepdfscreen(false);
    }
  };

  // const closeCompositionModal = (event) => {
  //   setShowComposition(false);
  //   console.log("patientProcedureList:", patientProcedureList);
  //   procedruelist(patientProcedureList.id, patientProcedureList.visit.id);
  //   if (event) {
  //     setMessageStrip(event);
  //   }
  // };

  const closeCompositionModal = (event) => {
    setSelectedTests("");
    setShowComposition(false);
    console.log("patientProcedureList:", patientProcedureList);
    if (
      patientProcedureList &&
      patientProcedureList.id &&
      patientProcedureList.visit
    ) {
      procedruelist(patientProcedureList.id, patientProcedureList.visit.id);
    }
    if (event) {
      setMessageStrip(event);
    }
  };

  const updateEprescription = (templateId, dbUItemplateid) => {
    console.log("template data: ", dbUItemplateid);
    console.log("patientEhrid:", patientEhrid);

    // Non-EHR org (e.g. Vedamaayu) — no ehrId, use notes JSON directly
    if (!patientEhrid || patientEhrid === "") {
      console.log("No ehrId, using notes JSON directly");

      const proc = patientProcedureList?.procedureslist?.find(
        p => p.templateId === dbUItemplateid && p.groupname === "EHR" && !p.compositionId
      );

      if (proc?.notes) {
        try {
          const notesJson = JSON.parse(proc.notes);
          jsonSchema.getSchemaFromCanonicalJson(
            notesJson,
            dbUItemplateid,
            "editComposition"
          ).then(form => {
            console.log("form from notes JSON:", form);
            seteprescription(form);

            // set lab report status same as EHR path
            if (
              notesJson?.archetype_details?.template_id?.value === "Laboratory Report" ||
              notesJson?.archetype_details?.template_id?.value === "Blood Glucose Profile" ||
              notesJson?.archetype_details?.template_id?.value === MULTILABREPORTS
            ) {
              setLabReportPrintStatus(true);
            } else {
              setLabReportPrintStatus(false);
            }
          });
        } catch (e) {
          console.error("Failed to parse notes JSON for non-EHR org", e);
        }
      } else {
        console.warn("No notes JSON found for non-EHR procedure");
      }
      return;
    }

    // EHR org — normal flow
    dispatch(
      ehrActions.getCompositionByVid(
        {},
        templateId,
        patientEhrid,
        async (resCb) => {
          console.log("resCb raw:", resCb);
          if (resCb) {
            console.log("templateId", templateId);
            console.log("API Response getCompositionByVid :", resCb);
            console.log("resc :", resCb.archetype_details);
            console.log("props", props);
            let template_id_value;
            if (dbUItemplateid == resCb.archetype_details.template_id.value) {
              template_id_value = resCb.archetype_details.template_id.value;
            } else {
              template_id_value = dbUItemplateid;
            }

            let form = await jsonSchema.getSchemaFromCanonicalJson(
              resCb,
              template_id_value,
              "editComposition",
            );
            console.log("formrrr", form);
            seteprescription(form);
            if (
              resCb.archetype_details.template_id.value == "Laboratory Report" ||
              resCb.archetype_details.template_id.value === "Blood Glucose Profile" ||
              resCb.archetype_details.template_id.value === MULTILABREPORTS
            ) {
              setLabReportPrintStatus(true);
            } else {
              setLabReportPrintStatus(false);
            }
            console.log("LabReportPrintStatus state", labReportPrintStatus);
          }
        },
      ),
    );
  };

  const serviceListModal = (presc, service, type) => {
    setselectedProcedure(presc);
    let continueService = service ? service : false;
    var role_name = JSON.parse(localStorage.getItem("role"));
    const notes = presc.combinedProcedures
      ? presc.combinedProcedures
        .filter(
          (proc) => !proc.shortdesc || proc.shortdesc.trim() === "" || proc.shortdesc === "OPEN", // short_desc empty
        )
        .map((proc) => (proc.notes ? proc.notes.trim() : null)) // safely map only valid notes
        .filter((notes) => notes) // remove null / undefined / empty
      : [];
    console.log(role_name, "role_name role_name");
    console.log(type, "type");
    console.log(notes, "notes");
    console.log(presc, "presc");
    if (type !== "ContinueService") {
      if (notes.length > 1) {
        setPrescData(presc);
        setNoteOptions(notes);
        setSelectedNotes(notes);
        setOpen(true);
      } else {
        continueService = true;
      }
    }
    if (continueService === true) {
      if (type === "CompositeUltrasound" && !presc.longdesc) {
        setCompositeUltrasound(true);
        setShowComposition(true);
        setTemplateId(
          presc.packageService.description
            ? presc.packageService.description
            : presc.templateId,
        );
        setselectedProcedure(presc);
      }
      if (presc.subgroup === RADIOLOGYREPORT) {
        setFlag("ultrasoundedit");
        setCompositeUltrasound(false);
        setShowComposition(true);
        setTemplateId(
          presc.packageService?.description
            ? presc.packageService.description
            : presc.templateId,
        );
        setselectedProcedure(presc);
        //setselectedProcedure({ ...presc, readOnly: true });
        return;
      }

      if (
        role_name == ROLE_KEYS.LabAdmin &&
        presc.packageService.serviceType === LAB
      ) {
        if (notes.length > 0 && type !== "CompositeUltrasound") {
          setCompositeUltrasound(false);
          setFlag("new");
          setShowComposition(true);
          setselectedProcedure(presc);
          setTemplateId(presc.packageService.name);
        }
      } else if (
        role_name === ROLE_KEYS.Ultrasound ||
        role_name === ROLE_KEYS.LabAdmin
      ) {
        setCompositeUltrasound(false);
        if (!presc.longdesc) {
          setShowComposition(true);
          console.log("presc.packageService.name", presc);
          setTemplateId(
            presc.packageService.description
              ? presc.packageService.description
              : presc.templateId,
          );
          setselectedProcedure(presc);
        } else if (presc.subgroup === RADIOLOGYREPORT) {
          setFlag("ultrasoundedit");
          setShowComposition(true);
          setTemplateId(
            presc.packageService?.description
              ? presc.packageService.description
              : presc.templateId,
          );
          setselectedProcedure(presc);
        }
      } else {
        setShowService(true);
      }
      presc.packageService.patientId = pData[0].patientId;
      presc.packageService.visitId = pData[0].visitId;
      presc.packageService.state = "update";
      setServiceDetails({ ...presc });
      console.log("serviceDetails", serviceDetails);
    }
  };

  const handleCheckboxChange = (note) => {
    setSelectedNotes((prev) =>
      prev.includes(note) ? prev.filter((n) => n !== note) : [...prev, note],
    );
  };

  const handleOk = () => {
    if (selectedProcedure.subgroup === "Lab_Report") {
      const updatedNotes = selectedNotes.join(", ");
      setSelectedTests(updatedNotes);
      zoomReviewModal(selectedProcedure, updatedNotes);
      setOpen(false);
    } else {
      const updatedNotes = selectedNotes.join(", ");
      const selectedProcedures =
        selectedProcedure.combinedProcedures?.filter((p) =>
          selectedNotes.some(
            (notes) => (notes || "").trim() === (p.notes || "").trim(),
          ),
        ) || [];

      const updatedPresc = {
        ...prescData,
        combinedNotes: updatedNotes,
        combinedProcedures: selectedProcedures,
      };
      setOpen(false);
      console.log("message obtained:", updatedPresc);
      serviceListModal(updatedPresc, true, "ContinueService");
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  function stripHtml(html) {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }

  const getNotesJson = (notes) => {
    if (typeof notes !== "string") return null;
    const trimmed = notes.trim();
    if (!trimmed || (trimmed[0] !== "{" && trimmed[0] !== "[")) return null;
    try {
      return JSON.parse(trimmed);
    } catch (e) {
      return null;
    }
  };

  const getCompositionElementValues = (composition) => {
    const values = new Map();

    const visit = (node) => {
      if (Array.isArray(node)) {
        node.forEach(visit);
        return;
      }
      if (!node || typeof node !== "object") return;

      if (node._type === "ELEMENT" && node.name?.value && node.value) {
        const value = node.value;
        let displayValue = value.value;
        if (displayValue === undefined) displayValue = value.magnitude;
        if (displayValue === undefined) displayValue = value.numerator;

        if (
          displayValue !== undefined &&
          displayValue !== null &&
          String(displayValue).trim() !== "" &&
          String(displayValue).toUpperCase() !== "NA"
        ) {
          const units = value.units ? ` ${value.units}` : "";
          values.set(node.name.value, `${displayValue}${units}`);
        }
      }

      Object.values(node).forEach(visit);
    };

    visit(composition);
    return values;
  };

  const renderClinicalCompositionNotes = (presc, notesJson) => {
    const compositionTemplate =
      notesJson?.archetype_details?.template_id?.value || presc?.templateId;
    const values = getCompositionElementValues(notesJson);

    if (compositionTemplate === DIAGNOSIS) {
      const details = [
        ["Clinical description", "Diagnosis"],
        ["Cause", "Cause"],
        ["Comment", "Comment"],
      ].filter(([field]) => values.has(field));
      return (
        <div style={{ width: "100%" }}>
          <div style={{ fontWeight: 700, marginBottom: "5px" }}>Diagnosis</div>
          {details.length ? details.map(([field, label]) => (
            <div key={field} style={{ padding: "2px 0" }}>
              <span style={{ fontWeight: 600 }}>{label}: </span>
              <span>{values.get(field)}</span>
            </div>
          )) : <span>No diagnosis details</span>}
        </div>
      );
    }

    if (compositionTemplate === VITAL_SIGNS) {
      const vitalFields = [
        ["Temperature", "Temperature"],
        ["Systolic", "Systolic BP"],
        ["Diastolic", "Diastolic BP"],
        ["Pulse Rate", "Pulse"],
        ["Respiratory Rate", "Respiration"],
        ["Oxygen Saturation Level (SpO₂)", "SpO₂"],
        ["Weight", "Weight"],
        ["Height/Length", "Height"],
        ["Body mass index", "BMI"],
      ];
      const details = vitalFields
        .filter(([field]) => values.has(field));
      return (
        <div style={{ width: "100%" }}>
          <div style={{ fontWeight: 700, marginBottom: "6px" }}>Vital Signs</div>
          {details.length ? (
            <div>
              {details.map(([field, label]) => (
                <div key={field} style={{ padding: "2px 0" }}>
                  <span style={{ fontWeight: 600 }}>{label}: </span>
                  <span>{values.get(field)}</span>
                </div>
              ))}
            </div>
          ) : <span>No vital-sign details</span>}
        </div>
      );
    }

    return null;
  };

  const isDischargeSummaryComposition = (presc) => {
    if (presc?.templateId === DISCHARGESUMMARY) return true;
    const notesJson = getNotesJson(presc?.notes);
    return (
      notesJson?._type === "COMPOSITION" &&
      notesJson?.archetype_details?.template_id?.value === DISCHARGESUMMARY
    );
  };

  const getCaseRecordValue = (value) => {
    if (value === null || value === undefined) return "";
    const text = stripHtml(String(value)).trim();
    if (
      !text ||
      text.toLowerCase() === "null" ||
      text.toLowerCase() === "undefined"
    ) {
      return "";
    }
    return text;
  };

  const truncateCaseRecordValue = (value, isParagraph) => {
    const limit = isParagraph ? 180 : 80;
    if (value.length <= limit) return value;
    return `${value.slice(0, limit).trimEnd()}...`;
  };

  const renderCaseRecordSummary = (presc) => {
    const recordType = getCaseRecordType(presc) || "doctor";
    const restrictToDoctorNotes =
      isReceptionOrAdmin && recordType === "doctor";

    const layout = restrictToDoctorNotes
      ? {
          title: "Doctor's Initial Assessment",
          sections: [
            {
              title: "Doctor Notes",
              fields: [["Doctor Notes", "Doctor Notes", true]],
            },
          ],
        }
      : CASE_RECORD_LAYOUTS[recordType] || CASE_RECORD_LAYOUTS.doctor;

    const records = presc.caseRecordGroup?.length
      ? presc.caseRecordGroup
      : [presc];
    const values = new Map();

    records.forEach((record) => {
      const value = getCaseRecordValue(record.notes);
      if (record.claSS && value) values.set(record.claSS, value);
    });

    const knownFields = new Set(
      layout.sections.flatMap((section) =>
        section.fields.map(([key]) => key),
      ),
    );
    const extraFieldMap = new Map();
    records.forEach((record) => {
      if (
        record.claSS &&
        !knownFields.has(record.claSS) &&
        getCaseRecordValue(record.notes)
      ) {
        extraFieldMap.set(record.claSS, [record.claSS, record.claSS, true]);
      }
    });
    const extraFields = restrictToDoctorNotes
      ? []
      : Array.from(extraFieldMap.values());
    const sections = extraFields.length
      ? [
          ...layout.sections,
          { title: "Other Information", fields: extraFields },
        ]
      : layout.sections;

    return (
      <div className="case-record-summary">
        <div className="case-record-summary__title">{layout.title}</div>
        {sections.map((section) => {
          const populatedFields = section.fields
            .map(([key, label, isParagraph]) => ({
              key,
              label,
              isParagraph: Boolean(isParagraph),
              value: values.get(key) || "",
            }))
            .filter((field) => field.value);

          if (!populatedFields.length) return null;

          return (
            <div className="case-record-summary__section" key={section.title}>
              <div className="case-record-summary__section-title">
                {section.title}
              </div>
              <div className="case-record-summary__grid">
                {populatedFields.map((field) => (
                  <div
                    className={`case-record-summary__field${
                      field.isParagraph
                        ? " case-record-summary__field--wide"
                        : ""
                    }`}
                    key={field.key}
                    title={field.value}
                  >
                    <span className="case-record-summary__label">
                      {field.label}:
                    </span>
                    <span className="case-record-summary__value">
                      {truncateCaseRecordValue(
                        field.value,
                        field.isParagraph,
                      )}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderDischargeSummaryValue = (record) => {
    if (record?.claSS === "Advice on discharge") {
      try {
        const medicines = JSON.parse(record.notes);
        if (Array.isArray(medicines)) {
          return medicines
            .map((medicine, index) => {
              const parts = [
                medicine?.medicine,
                medicine?.dose,
                medicine?.comment,
              ].filter(Boolean);
              return `${index + 1}. ${parts.join(" - ")}`;
            })
            .join("; ");
        }
      } catch (e) {
        // Fall back to the plain text renderer below.
      }
    }

    return getCaseRecordValue(record?.notes);
  };

  const renderCombinedDischargeSummary = (presc) => {
    const records = presc.dischargeSummaryGroup?.length
      ? presc.dischargeSummaryGroup
      : [presc];
    const values = new Map();

    records.forEach((record) => {
      const value = renderDischargeSummaryValue(record);
      if (record.claSS && value) values.set(record.claSS, value);
    });

    const knownFields = new Set(
      DISCHARGE_SUMMARY_LAYOUT.sections.flatMap((section) =>
        section.fields.map(([key]) => key),
      ),
    );
    const extraFieldMap = new Map();
    records.forEach((record) => {
      const value = renderDischargeSummaryValue(record);
      if (record.claSS && !knownFields.has(record.claSS) && value) {
        extraFieldMap.set(record.claSS, [record.claSS, record.claSS, true]);
      }
    });
    const extraFields = Array.from(extraFieldMap.values());
    const sections = extraFields.length
      ? [
          ...DISCHARGE_SUMMARY_LAYOUT.sections,
          { title: "Other Information", fields: extraFields },
        ]
      : DISCHARGE_SUMMARY_LAYOUT.sections;

    return (
      <div className="case-record-summary">
        <div className="case-record-summary__title">
          {DISCHARGE_SUMMARY_LAYOUT.title}
        </div>
        {sections.map((section) => {
          const populatedFields = section.fields
            .map(([key, label, isParagraph]) => ({
              key,
              label,
              isParagraph: Boolean(isParagraph),
              value: values.get(key) || "",
            }))
            .filter((field) => field.value);

          if (!populatedFields.length) return null;

          return (
            <div className="case-record-summary__section" key={section.title}>
              <div className="case-record-summary__section-title">
                {section.title}
              </div>
              <div className="case-record-summary__grid">
                {populatedFields.map((field) => (
                  <div
                    className={`case-record-summary__field${
                      field.isParagraph
                        ? " case-record-summary__field--wide"
                        : ""
                    }`}
                    key={field.key}
                    title={field.value}
                  >
                    <span className="case-record-summary__label">
                      {field.label}:
                    </span>
                    <span className="case-record-summary__value">
                      {truncateCaseRecordValue(
                        field.value,
                        field.isParagraph,
                      )}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const getPrescriptionPreviewRow = (procedure) => {
    try {
      const notesJson = getNotesJson(procedure?.notes);
      const items =
        notesJson?.content?.[0]?.activities?.[0]?.description?.items || [];

      const name =
        items.find(
          (item) => item.name?.value === "Local medicinal product brand",
        )?.value?.value || "-";
      const weightage =
        items.find((item) => item.name?.value === "Dose direction")?.items?.[0]
          ?.items?.[0]?.value?.value || "-";
      const consumption =
        items.find((item) => item.name?.value === "Instructions to patient")
          ?.value?.value || "-";
      const durationValue =
        items.find((item) => item.name?.value === "Dispense directions")
          ?.items?.[0]?.value?.value || "";
      const durationUnit =
        procedure?.durationUnit || notesJson?.durationUnit || "Days";
      const durationAlreadyHasUnit =
        /\b(day|days|month|months|year|years)\b/i.test(String(durationValue));
      const duration = durationValue
        ? durationAlreadyHasUnit
          ? durationValue
          : `${durationValue} ${durationUnit}`
        : "-";
      const comments =
        items.find((item) => item.name?.value === "Comment")?.value?.value ||
        "-";

      return {
        id: procedure?.id,
        name,
        weightage,
        consumption,
        duration,
        comments,
      };
    } catch (error) {
      return {
        id: procedure?.id,
        name: "-",
        weightage: "-",
        consumption: "-",
        duration: "-",
        comments: "-",
      };
    }
  };

  const renderPrescriptionTable = (prescriptions) => {
    const rows = prescriptions.map(getPrescriptionPreviewRow);

    return (
      <div className="prescription-table-scroll">
        <div
          style={{
            fontSize: "16px",
            fontWeight: 700,
            color: "#333",
            marginBottom: "8px",
          }}
        >
          Prescriptions
        </div>
        <table className="table table-bordered table-sm mb-0 prescription-preview-table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Weightage</th>
              <th scope="col">Consumption</th>
              <th scope="col">Duration</th>
              <th scope="col">Comments</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={row.id || index}>
                <td title={row.name}>{row.name}</td>
                <td title={row.weightage}>{row.weightage}</td>
                <td title={row.consumption}>{row.consumption}</td>
                <td title={row.duration}>{row.duration}</td>
                <td title={row.comments}>{row.comments}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const renderNotes = (presc) => {
    if (isDischargeSummaryComposition(presc)) return "";
    if (
      isPainAssessmentProcedure(presc) &&
      presc?.painAssessmentDetails
    ) {
      const assessment = presc.painAssessmentDetails;
      const examinationDate = assessment.examDateTime
        ? new Date(assessment.examDateTime)
        : null;
      const formattedExaminationDate =
        examinationDate && !Number.isNaN(examinationDate.getTime())
          ? examinationDate.toLocaleDateString("en-GB")
          : "Not available";

      return (
        <div className="case-record-summary">
          <div className="case-record-summary__title">Pain Assessment</div>

          <div className="case-record-summary__grid">
            <div className="case-record-summary__field case-record-summary__field--wide">
              <span className="case-record-summary__value">
                {assessment.doctorName || "Not available"}
              </span>
            </div>

            <div className="case-record-summary__field">
              <span className="case-record-summary__label">Pain Score:</span>
              <span className="case-record-summary__value">
                {assessment.painScore}/10
              </span>
            </div>

            <div className="case-record-summary__field">
              <span className="case-record-summary__label">Date:</span>
              <span className="case-record-summary__value">
                {formattedExaminationDate}
              </span>
            </div>

            <div className="case-record-summary__field case-record-summary__field--wide">
              <span className="case-record-summary__label">Diagnosis:</span>
              <span className="case-record-summary__value">
                {assessment.diagnosis || "Not available"}
              </span>
            </div>
          </div>
        </div>
      );
    }
    if (presc?.groupname === "EHR" && presc?.templateId === EPRESCRIPTION) {
      const prescriptions = presc?.combinedEhrPrescriptions?.length
        ? presc.combinedEhrPrescriptions
        : [presc];
      return renderPrescriptionTable(prescriptions);
    }
    // Support both current HTML notes and older JSON-based Case Studies.
    if (
      presc?.groupname === PROCEDURE_GROUPNAME_PATIENT_CASE_STUDY &&
      presc?.notes
    ) {
      try {
        const caseStudy =
          presc.caseStudyDetails ||
          parseCaseStudyData(presc.notes, presc.longdesc);
        const doctorName =
          caseStudy.doctorName ||
          caseStudy.updatedBy?.name ||
          presc.preparedBy ||
          "Not available";
        const caseStudyContent = caseStudy.notes;
        const isDeltaContent = Array.isArray(caseStudyContent?.ops);

        return (
          <div className="case-record-summary">
            <div className="case-record-summary__title">Patient Case Study</div>

            <div className="case-record-summary__grid">
              {caseStudy.date && (
                <div className="case-record-summary__field case-record-summary__field--wide">
                  <span className="case-record-summary__label">Date:</span>

                  <span className="case-record-summary__value">
                    {caseStudy.date
                      ? caseStudy.date.split("-").reverse().join("-")
                      : "Not available"}
                  </span>
                </div>
              )}

              <div className="case-record-summary__field case-record-summary__field--wide">
                <span className="case-record-summary__value">{doctorName}</span>
              </div>

              <div className="case-record-summary__field case-record-summary__field--wide">
                <div className="case-record-summary__label">Notes:</div>

                <div className="case-record-summary__value">
                  {isDeltaContent ? (
                    <ReactQuill
                      theme="bubble"
                      value={caseStudyContent}
                      readOnly
                      modules={{ toolbar: false }}
                    />
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          caseStudyContent || presc.longdesc || "",
                        ),
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      } catch (error) {
        return (
          <div className="case-record-summary">
            <div className="case-record-summary__title">Patient Case Study</div>

            <div className="case-record-summary__field case-record-summary__field--wide">
              <span className="case-record-summary__label">Notes:</span>

              <span className="case-record-summary__value">
                {presc.longdesc || stripHtml(presc.notes)}
              </span>
            </div>
          </div>
        );
      }
    }
    //  Grouped EHR prescriptions (non-EHR org) — show all medicines as numbered list
    if (presc?.combinedEhrLabel) {
      const lines = presc.combinedEhrLabel.split("||");
      return (
        <div>
          <b style={{ fontSize: "16px", color: "#333" }}>Prescriptions</b>
          {lines.map((line, i) => (
            <div key={i}>
              {i + 1}. {line}
            </div>
          ))}
        </div>
      );
    }

    //  Single EHR prescription (non-EHR org) — notes is full JSON
    if (presc?.groupname === "EHR" && presc?.notes) {
      try {
        const notesJson = getNotesJson(presc.notes);
        const clinicalNotes = renderClinicalCompositionNotes(presc, notesJson);
        if (clinicalNotes) return clinicalNotes;

        const items =
          notesJson?.content?.[0]?.activities?.[0]?.description?.items;
        if (items) {
          const medicine =
            items.find((i) => i.name?.value === "Local medicinal product brand")
              ?.value?.value || "";
          const dose =
            items.find((i) => i.name?.value === "Dose direction")?.items?.[0]
              ?.items?.[0]?.value?.value || "";
          const instructions =
            items.find((i) => i.name?.value === "Instructions to patient")
              ?.value?.value || "";
          const dispense =
            items.find((i) => i.name?.value === "Dispense directions")
              ?.items?.[0]?.value?.value || "";
          const comment =
            items.find((i) => i.name?.value === "Comment")?.value?.value || "";
          return `PRESCRIPTION :${medicine} ${dose} ${dispense} ${instructions} ${comment}`;
        }
      } catch (e) {
        // not JSON — old record, fall through
      }
    }

    // default
    return stripHtml(presc.notes);
  };
  const closeServiceModal = (event) => {
    console.log("message obtained:", event);
    setShowService(false);
    procedruelist(patientProcedureList?.id, patientProcedureList?.visit?.id);
    setMessageStrip(event);
  };
  const closeNotesModal = (event) => {
    console.log("message obtained:", event);
    setCaseRecordModal(false);
    procedruelist(patientProcedureList?.id, patientProcedureList?.visit?.id);
    setMessageStrip(event);
  };
  const closeCaseStudyModal = (event) => {
    setShowCaseStudy(false);
    setselectedProcedure(undefined);

    if (event) {
      setMessageStrip(event);
    }

    procedruelist(
      patientProcedureList?.id,
      patientProcedureList?.visit?.id,
    );
  };

  const openPainAssessmentForm = ({ patientId, visitId, subgroup, mode }) => {
    if (!isDoctorLogin) return;

    setShowCaseStudy(false);
    setPainAssessmentForm({ patientId, visitId, subgroup, mode });
  };

  const printPainAssessment = (presc, event) => {
    event?.preventDefault();
    event?.stopPropagation();

    const assessment = presc?.painAssessmentDetails;
    if (!assessment) return;

    setPainAssessmentPrint({
      patientInfo: {
        fullName: assessment.patientName,
        age: assessment.age,
        gender: assessment.gender,
        doctorName: assessment.doctorName,
        diagnosis: assessment.diagnosis,
        painScore: assessment.painScore,
        doctorSignature: assessment.doctorSignature,
        doctorSignedAt: assessment.doctorSignedAt,
        patientId: assessment.patientId,
        visitId: assessment.visitId,
      },
      regDate: assessment.examDateTime,
    });
  };

  const completePainAssessment = async (presc) => {
    const assessment = presc?.painAssessmentDetails;
    if (!assessment || assessment.status === ConsentFormStatus.completed) {
      return;
    }

    const confirmed = window.confirm(
      "Mark this Pain Assessment as completed? It will become read-only.",
    );
    if (!confirmed) return;

    setCompletingPainAssessment(assessment.subgroup);

    try {
      const response = await patientServices.addToProcedure({
        ...(assessment.statusRowId != null
          ? { id: assessment.statusRowId }
          : {}),
        claSS: "status",
        notes: ConsentFormStatus.completed,
        patientId: assessment.patientId,
        visitId: assessment.visitId,
        groupname: FormGroupName.Pain_Assessment_Form,
        subgroup: assessment.subgroup,
      });

      if (response?.errorMessages?.length) {
        throw new Error(response.errorMessages[0]);
      }

      setMessageStrip({
        success: "Pain Assessment completed successfully.",
      });
      procedruelist(assessment.patientId, assessment.visitId);
    } catch (error) {
      console.error("Failed to complete Pain Assessment:", error);
      setMessageStrip({
        error: "Unable to complete the Pain Assessment. Please try again.",
      });
    } finally {
      setCompletingPainAssessment("");
    }
  };

  const closePainAssessmentForm = (event) => {
    setPainAssessmentForm(null);

    if (event) {
      setMessageStrip(event);
    }

    procedruelist(
      patientProcedureList?.id,
      patientProcedureList?.visit?.id,
    );
  };

  const CloseAddConsultantModal = (e) => {
    setShowConsultant(false);
  };
  const editConsultant = (presc, event) => {
    setconsultantDetails({ ...presc });
    setShowConsultant(true);
  };

  const setMessageStrip = (e) => {
    var ServerResVal = ServerRes;
    if (e?.success) {
      ServerResVal.success = e?.success;
    } else {
      ServerResVal.error = e?.error;
    }
    setServerRes({ ...ServerResVal });
    setTimeout(() => {
      closeAlert();
    }, 5000);
  };

  const isPrintable = (presc) => {
    if (
      isPainAssessmentProcedure(presc) ||
      isDiagnosisOrVitalSignsProcedure(presc)
    )
      return false;

    const caseRecordType = getCaseRecordType(presc);
    if (
      presc.groupname === CASERECORD &&
      (caseRecordType === "doctor" || caseRecordType === "nurse")
    )
      return false;

    if (presc.subgroup === LABREPORT) return true;
    if (presc.subgroup === RADIOLOGYREPORT) return true;
    if (
      presc.notes &&
      presc.notes !== null &&
      presc.subgroup !== LABREPORT &&
      presc.groupname !== DISCHARGESUMMARY &&
      presc.groupname !== CASERECORD &&
      presc.templateId !== DFollowupNote &&
      presc.templateId !== CFollowupNote &&
      !presc.categoryServiceId &&
      presc.groupname !== "Consultant" &&
      presc.groupname !== "Appointment" &&
      !presc.uploads.imgurl
    )
      return true;
    if (
      presc.notes &&
      presc.notes !== null &&
      presc.groupname === DISCHARGESUMMARY
    )
      return true;

    if (
      presc.notes &&
      presc.notes != null &&
      presc.groupname === CASERECORD &&
      (org?.orgCode === ORG_CODES.MANASWINI ||
        org?.orgCode === ORG_CODES.VEDAMAAYU)
    )
      return true;

    return false;
  };

  const shouldShowPrescriptionPrintButton = (presc) => {
    if (!presc) return false;
    if (presc.combinedEhrLabel || presc.combinedEhrPrescriptions?.length) {
      return true;
    }
    if (
      presc.groupname === "EHR" &&
      presc.templateId === "ePrescription (epSoS/Contsys)"
    ) {
      return true;
    }
    return /^PRESCRIPTION\s*:/i.test(String(presc.notes || "").trim());
  };

  const processedLabBills = new Set();
  const processedEhrGroups = new Set();
  const processedCaseRecordGroups = new Set();
  // Prevent the paired Date/Notes rows from rendering as duplicate cards.
  const processedPatientCaseStudyGroups = new Set();
  const processedPainAssessmentGroups = new Set();
  const processedDischargeSummaryGroups = new Set();

  const getBaseBillNumber = (billNumber = "") => {
    return billNumber.split("::")[0];
  };

  const displayedProcedureList =
    patientProcedureList?.procedureslist?.filter((procedure) => {
      const showPainAssessmentConsent =
        isDoctorLogin || props.painAssessmentConsentOnly;

      if (
        !showPainAssessmentConsent &&
        isPainAssessmentProcedure(procedure)
      ) {
        return false;
      }

      if (
        showPainAssessmentConsent &&
        isNonPainConsentProcedure(procedure)
      ) {
        return false;
      }

      // Hide Patient Case Study from Reception/Admin users.
      if (
        isReceptionOrAdmin &&
        procedure.groupname === PROCEDURE_GROUPNAME_PATIENT_CASE_STUDY
      ) {
        return false;
      }

      if (!props.notesOnly) return true;

      const noteType = getCaseRecordType(procedure);

      return (
        procedure.groupname === CASERECORD &&
        (noteType === "doctor" || noteType === "nurse") &&
        !procedure.markForDel &&
        Boolean(procedure.notes?.trim())
      );
    }) || [];

  const renderedProcedures =
    patientProcedureList && patientProcedureList.procedureslist
      ? displayedProcedureList.map((presc, index) => {
        console.log("patientProcedureListd:", patientProcedureList);

        if (isPainAssessmentProcedure(presc) && !presc.markForDel) {
          const groupKey = getPainAssessmentGroupKey(presc);

          if (processedPainAssessmentGroups.has(groupKey)) {
            return null;
          }
          processedPainAssessmentGroups.add(groupKey);

          const assessment = buildPainAssessment(
            displayedProcedureList,
            presc,
          );
          if (!assessment) return null;

          return {
            type: "OTHER",
            presc: {
              ...presc,
              uploads: presc.uploads || {},
              cdt: assessment.updatedAt || presc.cdt,
              notes:
                assessment.diagnosis ||
                `Pain score: ${assessment.painScore}/10`,
              painAssessmentDetails: assessment,
            },
          };
        }

        if (
          presc.groupname === PROCEDURE_GROUPNAME_PATIENT_CASE_STUDY &&
          !presc.markForDel
        ) {
          const groupKey = getCaseStudyGroupKey(presc);

          if (processedPatientCaseStudyGroups.has(groupKey)) {
            return null;
          }
          processedPatientCaseStudyGroups.add(groupKey);

          const [caseStudy] = buildSelectedCaseStudies({
            allProcedures: displayedProcedureList,
            selectedProcedures: [presc],
            doctors: [
              ...(doctorList || []),
              props.selectedPatientInfo?.person,
            ].filter(Boolean),
          });

          if (!caseStudy) {
            return null;
          }

          return {
            type: "OTHER",
            presc: {
              ...presc,
              notes: caseStudy.notes,
              doctorId: caseStudy.doctorId,
              caseStudyDetails: caseStudy,
            },
          };
        }

        // ✅ Group EHR prescriptions (non-EHR org, same templateId + visitId)
        if (
          presc.groupname === "EHR" &&
          presc.templateId === "ePrescription (epSoS/Contsys)" &&
          //!presc.compositionId &&
          //commeneted for ehr testing if nit works uncomment this
          !presc.markForDel
        ) {
          const groupKey = presc.subgroup
            ? `${presc.visitId}_${presc.subgroup}`
            : `${presc.visitId}_${presc.id}`;

          if (processedEhrGroups.has(groupKey)) {
            return null;
          }
          processedEhrGroups.add(groupKey);

          const grouped = displayedProcedureList.filter((p) =>
            p.groupname === "EHR" &&
            p.templateId === presc.templateId &&
            p.visitId === presc.visitId &&
            // !p.compositionId &&
            !p.markForDel &&
            // p.subgroup === presc.subgroup
            (presc.subgroup ? p.subgroup === presc.subgroup : p.id === presc.id)
          );

          const combinedEhrLabel = grouped
            .map((p) => {
              try {
                const n = JSON.parse(p.notes);
                const items =
                  n?.content?.[0]?.activities?.[0]?.description?.items;
                const med =
                  items?.find(
                    (i) => i.name?.value === "Local medicinal product brand"
                  )?.value?.value || "";
                const dose =
                  items
                    ?.find((i) => i.name?.value === "Dose direction")
                    ?.items?.[0]?.items?.[0]?.value?.value || "";
                const instr =
                  items?.find(
                    (i) => i.name?.value === "Instructions to patient"
                  )?.value?.value || "";
                const dispense =
                  items
                    ?.find((i) => i.name?.value === "Dispense directions")
                    ?.items?.[0]?.value?.value || "";
                const comment =
                  items
                    ?.find(i => i.name?.value === "Comment")
                    ?.value?.value || "";
                return `${med} ${dose} ${instr} ${dispense} ${comment}`.trim();
              } catch {
                return p.notes;
              }
            })
            .join("||");

          const firstPresc = { ...grouped[0] };
          firstPresc.combinedEhrPrescriptions = grouped;
          firstPresc.combinedEhrLabel = combinedEhrLabel;

          return { type: "OTHER", presc: firstPresc };
        }
        if (
          presc.groupname === CASERECORD &&
          (getCaseRecordType(presc) === "doctor" ||
            getCaseRecordType(presc) === "nurse") &&
          !presc.markForDel
        ) {
          const caseRecordType = getCaseRecordType(presc);
          const groupKey = `${presc.patientId}_${presc.visitId}_${caseRecordType}`;
          if (processedCaseRecordGroups.has(groupKey)) {
            return null;
          }
          processedCaseRecordGroups.add(groupKey);

          const grouped = displayedProcedureList
            .filter(
              (p) =>
                p.groupname === CASERECORD &&
                getCaseRecordType(p) === caseRecordType &&
                p.visitId === presc.visitId &&
                !p.markForDel &&
                p.notes && p.notes.trim() !== ""
            )
            .sort(
              (a, b) =>
                new Date(a.cdt || a.udt || 0) - new Date(b.cdt || b.udt || 0)
            );

          const firstPresc = { ...(grouped[0] || presc) };
          firstPresc.caseRecordGroup = grouped;
          firstPresc.caseRecordSubgroup = caseRecordType;

          return { type: "OTHER", presc: firstPresc };
        }
        if (
          presc.groupname === DISCHARGESUMMARY &&
          !presc.markForDel &&
          presc.notes &&
          !isDischargeSummaryComposition(presc)
        ) {
          const groupKey = `${presc.patientId}_${presc.visitId}`;
          if (processedDischargeSummaryGroups.has(groupKey)) {
            return null;
          }
          processedDischargeSummaryGroups.add(groupKey);

          const grouped = displayedProcedureList
            .filter(
              (p) =>
                p.groupname === DISCHARGESUMMARY &&
                p.patientId === presc.patientId &&
                p.visitId === presc.visitId &&
                !p.markForDel &&
                p.notes &&
                !isDischargeSummaryComposition(p),
            )
            .sort(
              (a, b) =>
                new Date(a.cdt || a.udt || 0) - new Date(b.cdt || b.udt || 0),
            );

          const firstPresc = { ...(grouped[0] || presc) };
          firstPresc.dischargeSummaryGroup = grouped;

          return { type: "OTHER", presc: firstPresc };
        }

        if (
          presc.subgroup !== LABREPORT &&
          presc.packageService &&
          presc.packageService.serviceType === "LAB"
        ) {
          const bill = getBaseBillNumber(presc.billNumber);
          console.log("bill:", bill);

          const isSpecialProcedure =
            presc.groupname ===
            PROCEDURE_CONSTANTS_DETAILS.PROCEDURE_GROUPNAME_INVOICE &&
            presc.subgroup ===
            PROCEDURE_CONSTANTS_DETAILS.PROCEDURE_SUBGROUP_SO;

          if (processedLabBills.has(bill) && !isSpecialProcedure) {
            return null;
          }

          if (!isSpecialProcedure) {
            processedLabBills.add(bill);
          }

          const grouped = isSpecialProcedure
            ? [presc]
            : displayedProcedureList.filter(
              (p) =>
                p.packageService &&
                p.packageService.serviceType === "LAB" &&
                p.subgroup !== LABREPORT &&
                getBaseBillNumber(p.billNumber) === bill
            );
          console.log("grouped:", grouped);
          const groupedProc = grouped.filter(
            (p) =>
              p.subgroup !== LABREPORT &&
              (!p.shortdesc || !("shortdesc" in p) || p.shortdesc === "OPEN")
          );
          console.log("groupedProc:", groupedProc);
          const combinedNotes = grouped.map((p) => p.notes).join(", ");

          const totalAmount = grouped.reduce((sum, p) => {
            const amount = p.packageService.billAmount || 0;
            return sum + amount;
          }, 0);

          const firstPresc = grouped[0];

          firstPresc.combinedNotes = combinedNotes;
          firstPresc.totalAmount = totalAmount;
          firstPresc.combinedProcedures = groupedProc;
          firstPresc.type = "LAB";
          firstPresc.index = index;

          return { type: "LAB", presc: firstPresc };
        } else {
          return { type: "OTHER", presc };
        }
      })
      : [];

  return (
    <>
      {ServerRes.success && (
        <Alert severity="success" className="alert-div">
          {ServerRes.success}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}
      {ServerRes.error && (
        <Alert severity="error" className="alert-div">
          {ServerRes.error}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}

      <div
        className={
          `${!props.basic ? "pres-with-basic" : "layout-content"}${
            props.readOnly ? " read-only-procedure-list" : ""
          }${isDoctorLogin ? " doctor-patient-chat" : ""}`
        }
        id="patient-pres"
      >
        {props.notesOnly && (
          <div className="procedure-notes-page-title">
            Doctor and Nurse Notes
          </div>
        )}
        {!props.notesOnly && (
        <div className="d-flex justify-content-between position-fixed list-actions">
          <div
            className="back-icon"
            id="back-btn"
            onClick={(event) => backToUserList()}
          >
            <span class="material-icons">arrow_back</span>
          </div>
          <div className="filter-container px-3">
            {showFilterOptions ? (
              <div className="filter-options position-absolute">
                <div className="d-flex m-3 flex-wrap" style={{ gap: "12px" }}>
                  <div
                    className={
                      appliedFilters["uploads"]
                        ? "btn filter-btn mb-1 pb-2 mr-2 btn-dark active "
                        : "btn filter-btn mb-1 pb-2 mr-2"
                    }
                    onClick={(event) =>
                      applyFilter("uploads", appliedFilters.uploads)
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "100px",
                    }}
                  >
                    <CloudUploadIcon
                      fontSize="small"
                      className="mr-1 ml-2"
                      style={{ marginRight: "8px" }}
                    />
                    <span>Uploads</span>
                  </div>

                  <div
                    className={
                      appliedFilters["services"]
                        ? "btn filter-btn mr-2 pb-2 mb-1 btn-dark active"
                        : "btn filter-btn mb-1 pb-2 mr-2"
                    }
                    onClick={(event) =>
                      applyFilter("services", appliedFilters.services)
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "100px",
                    }}
                  >
                    <MedicalServicesIcon
                      fontSize="small"
                      className="mr-1"
                      style={{ marginRight: "8px" }}
                    />
                    <span>Services</span>
                  </div>

                  {/* <div
                      className={
                        appliedFilters["services"]
                          ? "btn filter-btn pb-2 btn-dark active"
                          : "btn filter-btn pb-2 "
                      }
                      onClick={(event) => applyFilter("services", appliedFilters.services)}
                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '100px' }}
                    >
                      <img
                        src="serviceImg4.png"
                        alt="Services Icon"
                        style={{
                          height: '20px',
                          width: '20px',
                          marginRight: '8px',
                          filter: appliedFilters["services"] ? 'brightness(0) invert(1)' : 'none'
                        }}
                      />
                      <span style={{ lineHeight: '1' }}>Services</span>
                    </div> */}

                  <div
                    className={
                      appliedFilters["templates"]
                        ? "btn filter-btn mr-2 pb-2 mb-1 mlbtn-dark active"
                        : "btn filter-btn mb-1 pb-2 mr-2"
                    }
                    onClick={(event) =>
                      applyFilter("templates", appliedFilters.templates)
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "100px",
                    }}
                  >
                    <DescriptionIcon
                      fontSize="small"
                      className="mr-1"
                      style={{ marginRight: "8px" }}
                    />
                    <span>EHR</span>
                  </div>

                  <div
                    className={
                      appliedFilters["prescriptions"]
                        ? "btn filter-btn mr-2 pb-2 mb-1 btn-dark active"
                        : "btn filter-btn mb-1 pb-2 mr-2"
                    }
                    onClick={(event) =>
                      applyFilter("prescriptions", appliedFilters.prescriptions)
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "100px",
                    }}
                  >
                    <MedicationIcon
                      fontSize="small"
                      className="mr-1"
                      style={{ marginRight: "8px" }}
                    />
                    <span>Prescriptions</span>
                  </div>

                  <div className="mr-2">
                    <select
                      name="Select Date"
                      value={selectedDate}
                      className="form-control"
                      onChange={(event) =>
                        handleChange(event, appliedFilters.date)
                      }
                    >
                      <option disabled={true} value="">
                        Select Visit Date
                      </option>
                      {allVisitdate.map((lastVisited, index) => (
                        <option key={index} value={lastVisited.id}>
                          {lastVisited.internalStatus !== "NotVisited" &&
                            getFormateDate(lastVisited.visitDate)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <span className="mainSpan">
              <i
                title="Filter"
                class="material-icons m-2 filter-icon"
                onClick={(event) => toggleFilterOptions()}
              >
                filter_list
              </i>
            </span>
          </div>
        </div>
        )}

        <div
          className={props.notesOnly ? "mt-3" : "mt-5"}
          id="procedure-list"
        >
          {props.notesOnly && renderedProcedures.every((item) => !item) && (
            <Alert severity="info">
              No doctor or nurse notes are available for this patient.
            </Alert>
          )}
          {renderedProcedures.map((item, index) => {
            if (!item) return null;
            const { presc } = item;
            return (
              <>
                {/* <div key={index} className={`${print ? 'set-width' : ''} ${(presc.notes && index+1 < patientProcedureList.procedureslist.length) && patientProcedureList.procedureslist[index].groupid === patientProcedureList.procedureslist[index+1].groupid ? 'hideNotes' : ''}`}> */}

                <div key={index} className={print ? "set-width" : ""}>
                  {!lab_admin === true &&
                    !radiology === true &&
                    !x_ray === true ? (
                    <>
                      {presc && !presc.markForDel && presc.notes && (
                        <>
                          {new Date(procedureDate).toDateString() !=
                            new Date(presc.cdt).toDateString() && (
                              <div
                                className="patient-lastvisit my-2 "
                                id={getFormateDate(presc.cdt)}
                              >
                                <span className="patient-lastvisit-date">
                                  {getFormateDate(presc.cdt)}
                                </span>
                              </div>
                            )}
                          <Grid
                            className={
                              presc.print
                                ? "form-group bg-highlight"
                                : "form-group"
                            }
                          >
                            <div key={index} className="p-0">
                              <CardContent className="p-0 d-flex align-items-center procedure-msg">
                                {presc.subgroup == LABREPORT ? (
                                  <>
                                    {print && isPrintable(presc) && (
                                      <div className="checkbox">
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc,
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )}
                                    <div
                                      className={
                                        print && isPrintable(presc)
                                          ? "set-width"
                                          : ""
                                      }
                                    >
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderStyle: "none",
                                                },
                                              }}
                                            >
                                              {presc.approver && (
                                                <MenuItem
                                                  className="drop-down-item"
                                                  onClick={(event) =>
                                                    takePrint(event, presc)
                                                  }
                                                >
                                                  Print
                                                </MenuItem>
                                              )}
                                            </Select>
                                          </div>
                                        </span>
                                        <span
                                          className="bubble-arrow"
                                          onClick={(event) =>
                                            zoomReviewModal(presc, event)
                                          }
                                        >
                                          <div className="pt-1">
                                            <label className="mb-0 mt-2">
                                              {presc.notes}
                                            </label>
                                            <br></br>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                                width: "100%",
                                              }}
                                            >
                                              {presc.approver && (
                                                <span>Verified</span>
                                              )}
                                              <span>
                                                {formatUdt(presc.cdt)}
                                              </span>
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.notes &&
                                  presc.notes != null &&
                                  presc.subgroup != LABREPORT &&
                                  presc.groupname != DISCHARGESUMMARY &&
                                  presc.groupname != CASERECORD &&
                                  presc.templateId != DFollowupNote &&
                                  presc.templateId != CFollowupNote ? (
                                  <>
                                    {print && isPrintable(presc) && (
                                      <div className="checkbox">
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc,
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )}
                                    {!presc.categoryServiceId &&
                                      presc.groupname != "Consultant" &&
                                      presc.groupname != "Appointment" &&
                                      !presc.uploads.imgurl &&
                                      presc.templateId != DFollowupNote &&
                                      !presc.uploads.imgurl &&
                                      presc.templateId != CFollowupNote && (
                                        <div
                                          className={
                                            print && isPrintable(presc)
                                              ? "set-width"
                                              : ""
                                          }
                                        >
                                          <div class="markForDelete">
                                            <Card
                                              small
                                              className="mb-0 h-100 abc note-card flex-wrap pt-2 presc-summary position-relative p-3"
                                              key={presc.id}
                                              style={{ maxWidth: "100%" }}
                                            >
                                              <span class="expand" style={{ display: "flex", alignItems: "center" }}>
                                                {isPainAssessmentProcedure(presc) ? (
                                                  <PainAssessmentActions
                                                    assessment={presc.painAssessmentDetails}
                                                    canEdit={isDoctorLogin}
                                                    completing={
                                                      completingPainAssessment ===
                                                      presc.painAssessmentDetails?.subgroup
                                                    }
                                                    onEdit={(event) => {
                                                      event.stopPropagation();
                                                      openPainAssessmentForm({
                                                        patientId: presc.patientId,
                                                        visitId: presc.visitId,
                                                        subgroup: presc.subgroup,
                                                        mode: "edit",
                                                      });
                                                    }}
                                                    onPrint={(event) =>
                                                      printPainAssessment(presc, event)
                                                    }
                                                    onComplete={() =>
                                                      completePainAssessment(presc)
                                                    }
                                                  />
                                                ) : shouldShowPrescriptionPrintButton(presc) && (
                                                  <button
                                                    type="button"
                                                    className="prescription-card-print-button"
                                                    title="Print prescription"
                                                    onClick={(event) => { event.stopPropagation(); takePrint(event, presc); }}
                                                  >
                                                    <span className="material-icons" aria-hidden="true">
                                                      print
                                                    </span>
                                                  </button>
                                                )}
                                                {!isPainAssessmentProcedure(presc) &&
                                                  !isDiagnosisOrVitalSignsProcedure(presc) && (
                                                  <div
                                                    open={presc.action}
                                                    toggle={() => toggle(index, presc)}
                                                    dropup
                                                  >
                                                    <Select
                                                      id="toggle_1"
                                                      sx={{
                                                        ".MuiOutlinedInput-notchedOutline": { borderStyle: "none" },
                                                      }}
                                                    >
                                                      {!(
                                                        props.readOnly &&
                                                        presc.groupname ===
                                                          PROCEDURE_GROUPNAME_PATIENT_CASE_STUDY
                                                      ) && (
                                                        <MenuItem
                                                          className="drop-down-item"
                                                          onClick={(event) =>
                                                            confirmDelete(
                                                              true,
                                                              event,
                                                              presc,
                                                            )
                                                          }
                                                        >
                                                          Delete
                                                        </MenuItem>
                                                      )}
                                                      <MenuItem
                                                        className="drop-down-item"
                                                        onClick={(event) => takePrint(event, presc)}
                                                      >
                                                        Print
                                                      </MenuItem>
                                                    </Select>
                                                  </div>
                                                )}
                                              </span>
                                              <span
                                                className="bubble-arrow"
                                                onClick={(event) => {
                                                  if (!isPainAssessmentProcedure(presc)) {
                                                    zoomReviewModal(presc, event);
                                                  }
                                                }}
                                              >
                                                <div className="pt-2">
                                                  <div className="mb-0 mt-2 w-100">
                                                    {renderNotes(presc)}
                                                  </div>
                                                  {/* {procedureNotes && procedureNotes.map((note,index)=>(
                                          <>
                                          <div key={index} className={note.notes}>

                                            <span className='bubble-arrow' onClick={(event) => zoomReviewModal(note,event)}>
                                              <div className=''>
                                                  <label className='mb-0'>{note.notes}</label>
                                              </div>
                                              <span style={{float: "right",fontSize: '12px',fontWeight:400}} className=''>{note.udt}</span>
                                            </span>

                                          </div>
                                          </>

                                        ))} */}
                                                </div>
                                                <div
                                                  style={{
                                                    float: "right",
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                  }}
                                                  className=""
                                                >
                                                  {formatUdt(presc.cdt)}
                                                </div>
                                              </span>
                                            </Card>
                                          </div>
                                        </div>
                                      )}
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.notes &&
                                  presc.notes != null &&
                                  presc.groupname === CASERECORD &&
                                  (props.notesOnly ||
                                    org?.orgCode === ORG_CODES.MANASWINI ||
                                    org?.orgCode === ORG_CODES.VEDAMAAYU) ? (
                                  <>
                                    {/* {print && (
                                      <div className="checkbox">
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    {!presc.categoryServiceId && (
                                      <div className={print ? "set-width" : ""}>
                                        <div class="markForDelete">
                                          <Card
                                            small
                                            className="mb-0 h-100 abc note-card flex-wrap pt-2 presc-summary case-record-card position-relative p-3"
                                            key={presc.id}
                                            style={{ maxWidth: "100%" }}
                                            onClick={(event) =>
                                              caseRecordView(presc)
                                            }
                                          >
                                            <span class="expand">
                                              <button
                                                type="button"
                                                className="prescription-card-print-button"
                                                title={`Print ${
                                                  getCaseRecordType(presc) ||
                                                  "doctor"
                                                } notes`}
                                                onClick={(event) =>
                                                  takeCaseRecordPrint(event, presc)
                                                }
                                              >
                                                <span
                                                  className="material-icons"
                                                  aria-hidden="true"
                                                >
                                                  print
                                                </span>
                                              </button>
                                            </span>
                                                <span
                                                  className="bubble-arrow"
                                                  onClick={(event) => {
                                                    event.stopPropagation();
                                                    caseRecordView(presc);
                                                  }}
                                                  >
                                                  <div className="pt-2">
                                                    {renderCaseRecordSummary(
                                                      presc,
                                                    )}
                                                  </div>
                                                  <div
                                                    style={{
                                                      float: "right",
                                                      fontSize: "12px",
                                                      fontWeight: 400,
                                                    }}
                                                    className=""
                                                  >
                                                    {formatUdt(presc.cdt)}
                                                  </div>
                                                </span>
                                          </Card>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.notes &&
                                  presc.notes != null &&
                                  presc.groupname === CASERECORD &&
                                  org?.orgCode === ORG_CODES.MNH ? (
                                  <>
                                    {print && isPrintable(presc) && (
                                      <div
                                        className="checkbox"
                                        style={{ visibility: "hidden" }}
                                      >
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc,
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )}
                                    {!presc.categoryServiceId && (
                                      <div
                                        className={
                                          print && isPrintable(presc)
                                            ? "set-width"
                                            : ""
                                        }
                                      >
                                        <div class="markForDelete">
                                          <Card
                                            small
                                            className="mb-0 h-100 abc note-card flex-wrap pt-2 presc-summary case-record-card position-relative p-3"
                                            key={presc.id}
                                            style={{ maxWidth: "100%" }}
                                          >
                                            <span class="expand">
                                              {!isDeleteProtectedProcedure(presc) && <div
                                                open={presc.action}
                                                toggle={() =>
                                                  toggle(index, presc)
                                                }
                                                dropup
                                              >
                                                <Select
                                                  id="toggle_1"
                                                  sx={{
                                                    ".MuiOutlinedInput-notchedOutline":
                                                      { borderStyle: "none" },
                                                  }}
                                                >
                                                  <MenuItem
                                                    className="drop-down-item"
                                                    onClick={(event) =>
                                                      confirmDelete(
                                                        true,
                                                        event,
                                                        presc,
                                                      )
                                                    }
                                                  >
                                                    Delete
                                                  </MenuItem>
                                                  {/* <MenuItem
                                                    className="drop-down-item"
                                                    onClick={(event) =>
                                                      takePrint(event, presc)
                                                    }
                                                  >
                                                    Print
                                                  </MenuItem> */}
                                                </Select>
                                              </div>}
                                            </span>
                                            <span
                                              className="bubble-arrow"
                                              onClick={(event) =>
                                                caseRecordView(presc)
                                              }
                                            >
                                              <div className="pt-2">
                                                <label className="mb-0 mt-2 w-100">
                                                  <b>{presc.claSS}:</b>{" "}
                                                  {presc.notes}
                                                </label>
                                              </div>
                                              <div
                                                style={{
                                                  float: "right",
                                                  fontSize: "12px",
                                                  fontWeight: 400,
                                                }}
                                                className=""
                                              >
                                                {formatUdt(presc.cdt)}
                                              </div>
                                            </span>
                                          </Card>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.groupname == "Consultant" ? (
                                  <>
                                    {/* {print && (
                                      <div className="checkbox" style={{ visibility: "hidden" }}>
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                  { borderStyle: "none" },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <span className="bubble-arrow">
                                          <div className="pt-2">
                                            <label className="mb-0 mt-2">
                                              {presc.shortdesc}
                                            </label>
                                            <br></br>
                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}

                                {presc.claSS != null &&
                                  presc.claSS === "complaint" ? (
                                  <>
                                    {/* {print && (
                                      <div className="checkbox" style={{ visibility: "hidden" }}>
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div className="pt-2">
                                            <label className="mb-0 mt-2">
                                              <b>{presc.claSS}:</b>{" "}
                                              {presc.notes}
                                            </label>
                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                  { borderStyle: "none" },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <span className="bubble-arrow">
                                          <div className="pt-2">
                                            <label className="mb-0 mt-2">
                                              {presc.complaint}
                                            </label>
                                            <br></br>
                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}

                                {presc.notes &&
                                  presc.notes != null &&
                                  presc.groupname === DISCHARGESUMMARY ? (
                                  <>
                                    {(print || dischargePrint) &&
                                      isPrintable(presc) && (
                                        <div className="checkbox">
                                          <input
                                            type="checkbox"
                                            id={presc.id}
                                            onChange={(event) =>
                                              selectForPrint(
                                                event.target.checked,
                                                presc,
                                              )
                                            }
                                          ></input>
                                        </div>
                                      )}
                                    <div
                                      className={
                                        dischargePrint && isPrintable(presc)
                                          ? "set-width"
                                          : ""
                                      }
                                    >
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap pt-2 presc-notes position-relative p-3"
                                        key={presc.id}
                                        style={{ maxWidth: "80%" }}
                                      >
                                        <span class="expand">
                                          <button
                                            type="button"
                                            className="prescription-card-print-button"
                                            title="Print discharge summary"
                                            onClick={(event) =>
                                              takeDirectDischargePrint(event, presc)
                                            }
                                          >
                                            <span
                                              className="material-icons"
                                              aria-hidden="true"
                                            >
                                              print
                                            </span>
                                          </button>
                                        </span>
                                        <span
                                          className="bubble-arrow"
                                          onClick={(event) =>
                                            dischargemodal(presc, event)
                                          }
                                        >
                                          <div className="pt-2">
                                            {presc.dischargeSummaryGroup ? (
                                              renderCombinedDischargeSummary(
                                                presc,
                                              )
                                            ) : (
                                              <div className="mb-0 mt-2 w-100 label-design">
                                                <b>{presc.claSS}:</b>{" "}
                                                {renderNotes(presc)}
                                              </div>
                                            )}
                                          </div>
                                          <div
                                            style={{
                                              float: "right",
                                              fontSize: "12px",
                                              fontWeight: 400,
                                            }}
                                            className=""
                                          >
                                            {formatUdt(presc.cdt)}
                                          </div>
                                        </span>
                                        <span></span>
                                      </Card>
                                      <div></div>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}

                                {presc.uploads?.imgurl &&
                                  presc.uploads?.type === "pdf" ? (
                                  <>
                                    {/* {print && (
                                      <div
                                        className="checkbox"
                                        style={{ visibility: "hidden" }}
                                      >
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap pt-4 upload-img position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                  { borderStyle: "none" },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <div className="markForDelete">
                                          <div
                                            className="pdf-card"
                                            style={{
                                              border: "1px solid #ccc",
                                              borderRadius: "8px",
                                              padding: "10px 14px",
                                              marginBottom: "10px",
                                              backgroundColor: "#f9f9f9",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              window.open(
                                                GET_UPLOAD_PATH +
                                                GET_LAB_PATH +
                                                presc.uploads.imgurl +
                                                ".pdf",
                                                "_blank",
                                              )
                                            }
                                          >
                                            <p
                                              style={{
                                                marginTop: "4px",
                                                color: "#666",
                                              }}
                                            >
                                              {presc.uploads.imgurl}
                                            </p>
                                          </div>
                                        </div>
                                        <span>
                                          <div
                                            style={{
                                              float: "right",
                                              fontSize: "12px",
                                              fontWeight: 400,
                                            }}
                                            className=""
                                          >
                                            {formatUdt(presc.cdt)}
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.uploads?.imgurl &&
                                  presc.uploads?.type === "png" ? (
                                  <>
                                    {/* {print && (
                                      <div
                                        className="checkbox"
                                        style={{ visibility: "hidden" }}
                                      >
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap pt-4 upload-img position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderStyle: "none",
                                                },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <div class="markForDelete">
                                          <img
                                            src={
                                              GET_UPLOAD_PATH +
                                              GET_UPLOAD_HOSPITAL_PATH +
                                              presc.uploads.imgurl
                                            }
                                            className="pres-img"
                                            style={{ cursor: `pointer` }}
                                            onClick={(event) =>
                                              showImage(index)
                                            }
                                          ></img>
                                        </div>
                                        <span>
                                          <div
                                            style={{
                                              float: "right",
                                              fontSize: "12px",
                                              fontWeight: 400,
                                            }}
                                            className=""
                                          >
                                            {formatUdt(presc.cdt)}
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.categoryServiceId &&
                                  presc.groupname != "Consultant" &&
                                  presc.packageService.serviceType !== LAB &&
                                  presc.subgroup !== LABREPORT ? (
                                  <>
                                    {/* {print && (
                                      <div className="checkbox" style={{ visibility: "hidden" }}>
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                  { borderStyle: "none" },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <span
                                          className="bubble-arrow"
                                          onClick={(event) =>
                                            serviceListModal(presc)
                                          }
                                        >
                                          <div className="pt-1">
                                            <label className="mb-0 mt-2">
                                              {presc.notes}
                                            </label>
                                            <br></br>
                                            {/* <label className="mb-0 mt-2">{presc.packageService.description}</label><br></br> */}

                                            <span style={{ fontWeight: 400 }}>
                                              {" "}
                                              {presc.packageService.billAmount >
                                                0
                                                ? "Rs. " +
                                                presc.packageService
                                                  .billAmount +
                                                " per unit"
                                                : "No charges Applied"}
                                              {presc.packageService.quantity > 1
                                                ? ", " +
                                                presc.packageService
                                                  .quantity +
                                                " units"
                                                : ""}
                                            </span>
                                            <br></br>

                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.categoryServiceId &&
                                  presc.packageService.serviceType === LAB &&
                                  presc.subgroup !== LABREPORT ? (
                                  <>
                                    {/* {print && (
                                                <div className="checkbox" style={{ visibility: "hidden" }}>
                                                  <input
                                                    type="checkbox"
                                                    id={presc.id}
                                                    onChange={(event) =>
                                                      selectForPrint(
                                                        event.target.checked,
                                                        presc
                                                      )
                                                    }
                                                  ></input>
                                                </div>
                                              )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderStyle: "none",
                                                },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <span
                                          className="bubble-arrow"
                                          onClick={(event) =>
                                            serviceListModal(presc)
                                          }
                                        >
                                          <div className="pt-1">
                                            <label className="mb-0 mt-2">
                                              {presc.combinedNotes}
                                            </label>
                                            <br></br>
                                            {/* <label className="mb-0 mt-2">{presc.packageService.description}</label><br></br> */}

                                            <span
                                              style={{
                                                fontWeight: 400,
                                              }}
                                            >
                                              {" "}
                                              {presc.totalAmount > 0
                                                ? "Rs. " +
                                                presc.totalAmount +
                                                " per unit"
                                                : "No charges Applied"}
                                              {presc.packageService.quantity > 1
                                                ? ", " +
                                                presc.packageService
                                                  .quantity +
                                                " units"
                                                : ""}
                                            </span>
                                            <br></br>

                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.templateId == DFollowupNote ? (
                                  <>
                                    {/* {print && (
                                      <div className="checkbox" style={{ visibility: "hidden" }}>
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                  { borderStyle: "none" },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <span
                                          className="bubble-arrow"
                                          onClick={(event) =>
                                            zoomReviewModal(presc, event)
                                          }
                                        >
                                          <div className="pt-1">
                                            <label className="mb-0 mt-2">
                                              <b>Doctor's Followup : </b>
                                              {presc.notes}
                                            </label>
                                            <br></br>
                                            {/* <label className="mb-0 mt-2">{presc.packageService.description}</label><br></br> */}

                                            {/* <span style={{ fontWeight: 400 }}> {presc.packageService.billAmount > 0 ? 'Rs. ' + presc.packageService.billAmount + ' per unit' : 'No charges Applied'}
                                        {presc.packageService.quantity > 1 ? ', ' + presc.packageService.quantity + ' units' : ''}
                                      </span> */}
                                            {/* <br></br> */}

                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.templateId == CFollowupNote ? (
                                  <>
                                    {/* {print && (
                                      <div className="checkbox" style={{ visibility: "hidden" }}>
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                  { borderStyle: "none" },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <span
                                          className="bubble-arrow"
                                          onClick={(event) =>
                                            zoomReviewModal(presc, event)
                                          }
                                        >
                                          <div className="pt-1">
                                            <label className="mb-0 mt-2">
                                              <b>Counsellor's Followup : </b>
                                              {presc.notes}
                                            </label>
                                            <br></br>
                                            {/* <label className="mb-0 mt-2">{presc.packageService.description}</label><br></br> */}

                                            {/* <span style={{ fontWeight: 400 }}> {presc.packageService.billAmount > 0 ? 'Rs. ' + presc.packageService.billAmount + ' per unit' : 'No charges Applied'}

                                          {presc.packageService.quantity > 1 ? ', ' + presc.packageService.quantity + ' units' : ''}
                                        </span> */}
                                            {/* <br></br> */}

                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}

                                {presc.claSS != null &&
                                  presc.claSS === "complaint" ? (
                                  <>
                                    {/* {print && (
                                      <div className="checkbox" style={{ visibility: "hidden" }}>
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                  { borderStyle: "none" },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <span className="bubble-arrow">
                                          <div className="pt-2">
                                            <label className="mb-0 mt-2">
                                              {presc.complaint}
                                            </label>
                                            <br></br>
                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}

                                {presc.claSS != null &&
                                  presc.claSS === "AssignDoctor" ? (
                                  <>
                                    {/* {print && (
                                      <div className="checkbox" style={{ visibility: "hidden" }}>
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                  { borderStyle: "none" },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <span className="bubble-arrow">
                                          <div className="pt-2">
                                            <label className="mb-0 mt-2">
                                              {presc.shortdesc}
                                            </label>
                                            <br></br>
                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}

                                {presc.groupname != null &&
                                  presc.groupname === "Appointment" ? (
                                  <>
                                    {/* {print && (
                                      <div className="checkbox" style={{ visibility: "hidden" }}>
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                  { borderStyle: "none" },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <span className="bubble-arrow">
                                          <div className="pt-2">
                                            <label className="mb-0 mt-2">
                                              {presc.shortdesc}
                                            </label>
                                            <br></br>
                                            <div
                                              style={{
                                                float: "right",
                                                fontSize: "12px",
                                                fontWeight: 400,
                                              }}
                                              className=""
                                            >
                                              {formatUdt(presc.cdt)}
                                            </div>
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                              </CardContent>
                            </div>
                          </Grid>

                          <Dialog
                            open={openDeleteModal}
                            toggle={() => handleopenDeleteModal()}
                          >
                            <DialogTitle>Delete</DialogTitle>
                            <DialogContent>
                              This cannot be undone. Are you sure you want to
                              delete?
                            </DialogContent>
                            <DialogActions
                              style={{ justifyContent: `space-between` }}
                            >
                              <Button
                                color="primary"
                                varient="contained"
                                onClick={handleopenDeleteModal}
                              >
                                Cancel
                              </Button>
                              <Button
                                color="primary"
                                varient="contained"
                                onClick={(event) => markForDel(presc, event)}
                              >
                                Delete
                              </Button>
                            </DialogActions>
                          </Dialog>

                          {/*
                                  <Dialog
                                  open={onmodal}
                                  toggle={closeModal}
                                    >
                                  <DialogContent> Patient already has been sent for Billing. If you need to add/delete services/charges please do it in the Billing module.</DialogContent>
                                                            <DialogActions style={{ justifyContent: `space-between` }}>
                                                              <Button color="primary" varient="contained"
                                                                onClick={closeDelete}
                                                              >
                                                                Cancel
                                                              </Button>
                                                            </DialogActions>
                                                          </Dialog> */}

                          <Dialog
                            className="d-flex w-95 h-90 flex-column-reverse "
                            id="closemodalopen"
                            open={onmodal}
                            toggle={closeDelete}
                          >
                            <div>
                              <DialogTitle>
                                Warning!
                                <IconButton
                                  aria-label="close"
                                  onClick={closeDelete}
                                  sx={{
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </DialogTitle>

                              <DialogContent>
                                <span>
                                  Patient already has been sent for Billing. If
                                  you need to add/delete services/charges please
                                  do it in the Billing module.
                                </span>
                              </DialogContent>
                              <DialogActions>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className="btn btn-submit btn-primary btn-style bottomright"
                                  onClick={closeDelete}
                                  style={{ textTransform: "none" }}
                                >
                                  Cancel
                                </Button>
                              </DialogActions>
                            </div>
                          </Dialog>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {presc && !presc.markForDel && presc.notes && (
                        <>
                          {new Date(procedureDate).toDateString() !=
                            new Date(presc.cdt).toDateString() && (
                              <div
                                className="patient-lastvisit my-2 "
                                id={getFormateDate(presc.cdt)}
                              >
                                <span className="patient-lastvisit-date">
                                  {getFormateDate(presc.cdt)}
                                </span>
                              </div>
                            )}
                          <Grid
                            className={
                              presc.print
                                ? "form-group bg-highlight"
                                : "form-group"
                            }
                          >
                            <div key={index} className="p-0">
                              <CardContent className="p-0 d-flex align-items-center procedure-msg">
                                {presc.uploads?.imgurl &&
                                  presc.uploads.type == "pdf" &&
                                  gvid === presc.gvid ? (
                                  <>
                                    {/* {print && (
                                      <div
                                        className="checkbox"
                                        style={{ visibility: "hidden" }}
                                      >
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap pt-4 upload-img position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderStyle: "none",
                                                },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <div className="markForDelete">
                                          <div
                                            className="pdf-card"
                                            style={{
                                              border: "1px solid #ccc",
                                              borderRadius: "8px",
                                              padding: "10px 14px",
                                              marginBottom: "10px",
                                              backgroundColor: "#f9f9f9",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              window.open(
                                                GET_UPLOAD_PATH +
                                                GET_LAB_PATH +
                                                presc.uploads.imgurl +
                                                ".pdf",
                                                "_blank",
                                              )
                                            }
                                          >
                                            <p
                                              style={{
                                                marginTop: "4px",
                                                color: "#666",
                                              }}
                                            >
                                              {presc.uploads.imgurl}
                                            </p>
                                          </div>
                                        </div>
                                        <span>
                                          <div
                                            style={{
                                              float: "right",
                                              fontSize: "12px",
                                              fontWeight: 400,
                                            }}
                                            className=""
                                          >
                                            {formatUdt(presc.cdt)}
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc.uploads?.imgurl &&
                                  presc.uploads?.type === "png" &&
                                  gvid === presc.gvid ? (
                                  <>
                                    {/* {print && (
                                      <div
                                        className="checkbox"
                                        style={{ visibility: "hidden" }}
                                      >
                                        <input
                                          type="checkbox"
                                          id={presc.id}
                                          onChange={(event) =>
                                            selectForPrint(
                                              event.target.checked,
                                              presc
                                            )
                                          }
                                        ></input>
                                      </div>
                                    )} */}
                                    <div className={print ? "set-width" : ""}>
                                      <Card
                                        small
                                        className="mb-0 h-100 note-card flex-wrap pt-4 upload-img position-relative p-3"
                                      >
                                        <span class="expand">
                                          <div
                                            open={presc.action}
                                            toggle={() => toggle(index, presc)}
                                            dropup
                                          >
                                            <Select
                                              id="toggle_1"
                                              sx={{
                                                ".MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderStyle: "none",
                                                },
                                              }}
                                            >
                                              <MenuItem
                                                className="drop-down-item"
                                                onClick={(event) =>
                                                  confirmDelete(
                                                    true,
                                                    event,
                                                    presc,
                                                  )
                                                }
                                              >
                                                Delete
                                              </MenuItem>
                                            </Select>
                                          </div>
                                        </span>
                                        <div class="markForDelete">
                                          <img
                                            src={
                                              GET_UPLOAD_PATH +
                                              GET_UPLOAD_HOSPITAL_PATH +
                                              presc.uploads.imgurl
                                            }
                                            className="pres-img"
                                            style={{ cursor: `pointer` }}
                                            onClick={(event) =>
                                              showImage(index)
                                            }
                                          ></img>
                                        </div>
                                        <span>
                                          <div
                                            style={{
                                              float: "right",
                                              fontSize: "12px",
                                              fontWeight: 400,
                                            }}
                                            className=""
                                          >
                                            {formatUdt(presc.cdt)}
                                          </div>
                                        </span>
                                      </Card>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                {presc && !presc.markForDel && presc.notes && (
                                  <>
                                    {new Date(procedureDate).toDateString() !==
                                      new Date(presc.cdt).toDateString() && (
                                        <div
                                          className="patient-lastvisit my-2"
                                          id={getFormateDate(presc.cdt)}
                                        >
                                          <span className="patient-lastvisit-date">
                                            {getFormateDate(presc.cdt)}
                                          </span>
                                        </div>
                                      )}
                                    <Grid
                                      className={
                                        presc.print
                                          ? "form-group bg-highlight"
                                          : "form-group"
                                      }
                                    >
                                      <div key={index} className="p-0">
                                        <CardContent className="p-0 d-flex align-items-center procedure-msg">
                                          {(radiology || lab_admin) &&
                                            presc.subgroup === LABREPORT ? (
                                            <>
                                              {print && isPrintable(presc) && (
                                                <div className="checkbox">
                                                  <input
                                                    type="checkbox"
                                                    id={presc.id}
                                                    onChange={(event) =>
                                                      selectForPrint(
                                                        event.target.checked,
                                                        presc,
                                                      )
                                                    }
                                                  ></input>
                                                </div>
                                              )}
                                              <div
                                                className={
                                                  print && isPrintable(presc)
                                                    ? "set-width"
                                                    : ""
                                                }
                                              >
                                                <Card
                                                  small
                                                  className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                                >
                                                  <span class="expand">
                                                    <div
                                                      open={presc.action}
                                                      toggle={() =>
                                                        toggle(index, presc)
                                                      }
                                                      dropup
                                                    >
                                                      <Select
                                                        id="toggle_1"
                                                        sx={{
                                                          ".MuiOutlinedInput-notchedOutline":
                                                          {
                                                            borderStyle:
                                                              "none",
                                                          },
                                                        }}
                                                      >
                                                        {
                                                          <MenuItem
                                                            className="drop-down-item"
                                                            onClick={(event) =>
                                                              takePrint(
                                                                event,
                                                                presc,
                                                              )
                                                            }
                                                          >
                                                            Print
                                                          </MenuItem>
                                                        }
                                                        {
                                                          <MenuItem
                                                            className="drop-down-item"
                                                            onClick={(event) =>
                                                              takeEdit(
                                                                event,
                                                                presc,
                                                              )
                                                            }
                                                          >
                                                            Edit
                                                          </MenuItem>
                                                        }
                                                      </Select>
                                                    </div>
                                                  </span>
                                                  <span
                                                    className="bubble-arrow"
                                                    onClick={(event) =>
                                                      zoomReviewModal(
                                                        presc,
                                                        event,
                                                      )
                                                    }
                                                  >
                                                    <div className="pt-1">
                                                      <label className="mb-0 mt-2">
                                                        {presc.notes}
                                                      </label>
                                                      <br></br>
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                          fontSize: "12px",
                                                          fontWeight: 400,
                                                          width: "100%",
                                                        }}
                                                      >
                                                        {presc.approver && (
                                                          <span>Verified</span>
                                                        )}
                                                        <span>
                                                          {formatUdt(presc.cdt)}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </span>
                                                </Card>
                                              </div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {(radiology || lab_admin) &&
                                            presc.subgroup == RADIOLOGYREPORT ? (
                                            <>
                                              {print && isPrintable(presc) && (
                                                <div className="checkbox">
                                                  <input
                                                    type="checkbox"
                                                    id={presc.id}
                                                    onChange={(event) =>
                                                      selectForPrint(
                                                        event.target.checked,
                                                        presc,
                                                      )
                                                    }
                                                  ></input>
                                                </div>
                                              )}
                                              <div
                                                className={
                                                  print && isPrintable(presc)
                                                    ? "set-width"
                                                    : ""
                                                }
                                              >
                                                <Card
                                                  small
                                                  className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                                >
                                                  <span class="expand">
                                                    <div
                                                      open={presc.action}
                                                      toggle={() =>
                                                        toggle(index, presc)
                                                      }
                                                      dropup
                                                    >
                                                      <Select
                                                        id="toggle_1"
                                                        sx={{
                                                          ".MuiOutlinedInput-notchedOutline":
                                                          {
                                                            borderStyle:
                                                              "none",
                                                          },
                                                        }}
                                                      >
                                                        <MenuItem
                                                          className="drop-down-item"
                                                          onClick={(event) =>
                                                            confirmDelete(
                                                              true,
                                                              event,
                                                              presc,
                                                            )
                                                          }
                                                        >
                                                          Delete
                                                        </MenuItem>
                                                        <MenuItem
                                                          className="drop-down-item"
                                                          onClick={(event) =>
                                                            takePrint(
                                                              event,
                                                              presc,
                                                            )
                                                          }
                                                        >
                                                          Print
                                                        </MenuItem>
                                                      </Select>
                                                    </div>
                                                  </span>
                                                  <span
                                                    className="bubble-arrow"
                                                    onClick={(event) =>
                                                      zoomReviewModal(
                                                        presc,
                                                        event,
                                                      )
                                                    }
                                                  >
                                                    <div className="pt-1">
                                                      <label className="mb-0 mt-2">
                                                        {presc.notes}
                                                      </label>
                                                      <br></br>
                                                      <div
                                                        style={{
                                                          float: "right",
                                                          fontSize: "12px",
                                                          fontWeight: 400,
                                                        }}
                                                        className=""
                                                      >
                                                        {formatUdt(presc.cdt)}
                                                      </div>
                                                    </div>
                                                  </span>
                                                </Card>
                                              </div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {(radiology || lab_admin) &&
                                            presc.categoryServiceId &&
                                            presc.packageService?.serviceType ===
                                            "ULTRASOUND" ? (
                                            <>
                                              {/* {print && (
                                                <div className="checkbox" style={{ visibility: "hidden" }}>
                                                  <input
                                                    type="checkbox"
                                                    id={presc.id}
                                                    onChange={(event) =>
                                                      selectForPrint(
                                                        event.target.checked,
                                                        presc
                                                      )
                                                    }
                                                  ></input>
                                                </div>
                                              )} */}
                                              <div
                                                className={
                                                  print ? "set-width" : ""
                                                }
                                              >
                                                <Card
                                                  small
                                                  className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                                >
                                                  <span class="expand">
                                                    <div
                                                      open={presc.action}
                                                      toggle={() =>
                                                        toggle(index, presc)
                                                      }
                                                      dropup
                                                    >
                                                      <Select
                                                        id="toggle_1"
                                                        sx={{
                                                          ".MuiOutlinedInput-notchedOutline":
                                                          {
                                                            borderStyle:
                                                              "none",
                                                          },
                                                        }}
                                                      >
                                                        <MenuItem
                                                          className="drop-down-item"
                                                          onClick={(event) =>
                                                            confirmDelete(
                                                              true,
                                                              event,
                                                              presc,
                                                            )
                                                          }
                                                        >
                                                          Delete
                                                        </MenuItem>
                                                      </Select>
                                                    </div>
                                                  </span>
                                                  <span
                                                    className="bubble-arrow"
                                                    onClick={(event) =>
                                                      serviceListModal(presc)
                                                    }
                                                  >
                                                    <div className="pt-1">
                                                      <label className="mb-0 mt-2">
                                                        {presc.notes}
                                                      </label>
                                                      <br></br>
                                                      {/* <label className="mb-0 mt-2">{presc.packageService.description}</label><br></br> */}

                                                      <span
                                                        style={{
                                                          fontWeight: 400,
                                                        }}
                                                      >
                                                        {" "}
                                                        {presc.packageService
                                                          .billAmount > 0
                                                          ? "Rs. " +
                                                          presc.packageService
                                                            .billAmount +
                                                          " per unit"
                                                          : "No charges Applied"}
                                                        {presc.packageService
                                                          .quantity > 1
                                                          ? ", " +
                                                          presc.packageService
                                                            .quantity +
                                                          " units"
                                                          : ""}
                                                      </span>
                                                      <br></br>

                                                      <div
                                                        style={{
                                                          float: "right",
                                                          fontSize: "12px",
                                                          fontWeight: 400,
                                                        }}
                                                        className=""
                                                      >
                                                        {formatUdt(presc.cdt)}
                                                      </div>
                                                    </div>
                                                  </span>
                                                </Card>
                                              </div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {(radiology || lab_admin) &&
                                            presc.categoryServiceId &&
                                            presc.packageService.serviceType ===
                                            LAB &&
                                            presc.subgroup !== LABREPORT ? (
                                            <>
                                              <div
                                                className={
                                                  print ? "set-width" : ""
                                                }
                                              >
                                                <Card
                                                  small
                                                  className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                                >
                                                  <span class="expand">
                                                    <div
                                                      open={presc.action}
                                                      toggle={() =>
                                                        toggle(index, presc)
                                                      }
                                                      dropup
                                                    >
                                                      <Select
                                                        id="toggle_1"
                                                        sx={{
                                                          ".MuiOutlinedInput-notchedOutline":
                                                          {
                                                            borderStyle:
                                                              "none",
                                                          },
                                                        }}
                                                      >
                                                        <MenuItem
                                                          className="drop-down-item"
                                                          onClick={(event) =>
                                                            confirmDelete(
                                                              true,
                                                              event,
                                                              presc,
                                                            )
                                                          }
                                                        >
                                                          Delete
                                                        </MenuItem>
                                                      </Select>
                                                    </div>
                                                  </span>
                                                  <span
                                                    className="bubble-arrow"
                                                    onClick={(event) =>
                                                      serviceListModal(presc)
                                                    }
                                                  >
                                                    <div className="pt-1">
                                                      <label className="mb-0 mt-2">
                                                        {presc.combinedNotes}
                                                      </label>
                                                      <br></br>
                                                      {/* <label className="mb-0 mt-2">{presc.packageService.description}</label><br></br> */}

                                                      <span
                                                        style={{
                                                          fontWeight: 400,
                                                        }}
                                                      >
                                                        {" "}
                                                        {presc.totalAmount > 0
                                                          ? "Rs. " +
                                                          presc.totalAmount +
                                                          " per unit"
                                                          : "No charges Applied"}
                                                        {presc.packageService
                                                          .quantity > 1
                                                          ? ", " +
                                                          presc.packageService
                                                            .quantity +
                                                          " units"
                                                          : ""}
                                                      </span>
                                                      <br></br>

                                                      <div
                                                        style={{
                                                          float: "right",
                                                          fontSize: "12px",
                                                          fontWeight: 400,
                                                        }}
                                                        className=""
                                                      >
                                                        {formatUdt(presc.cdt)}
                                                      </div>
                                                    </div>
                                                  </span>
                                                </Card>
                                              </div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {(radiology || lab_admin) &&
                                            presc.subgroup !== LABREPORT &&
                                            presc.packageService?.compositeService
                                              ?.toUpperCase()
                                              .includes("ULTRASOUND") ? (
                                            <>
                                              <div
                                                className={
                                                  print ? "set-width" : ""
                                                }
                                              >
                                                <Card
                                                  small
                                                  className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                                >
                                                  <span class="expand">
                                                    <div
                                                      open={presc.action}
                                                      toggle={() =>
                                                        toggle(index, presc)
                                                      }
                                                      dropup
                                                    >
                                                      <Select
                                                        id="toggle_1"
                                                        sx={{
                                                          ".MuiOutlinedInput-notchedOutline":
                                                          {
                                                            borderStyle:
                                                              "none",
                                                          },
                                                        }}
                                                      >
                                                        <MenuItem
                                                          className="drop-down-item"
                                                          onClick={(event) =>
                                                            confirmDelete(
                                                              true,
                                                              event,
                                                              presc,
                                                            )
                                                          }
                                                        >
                                                          Delete
                                                        </MenuItem>
                                                      </Select>
                                                    </div>
                                                  </span>
                                                  <span
                                                    className="bubble-arrow"
                                                    onClick={(event) =>
                                                      serviceListModal(
                                                        presc,
                                                        event,
                                                        "CompositeUltrasound",
                                                      )
                                                    }
                                                  >
                                                    <div className="pt-1">
                                                      <label className="mb-0 mt-2">
                                                        {`${presc.notes} - ULTRASOUND`}
                                                      </label>
                                                      <br></br>
                                                      <span
                                                        style={{
                                                          fontWeight: 400,
                                                        }}
                                                      >
                                                        {" "}
                                                        {presc.packageService
                                                          .billAmount > 0
                                                          ? "Rs. " +
                                                          presc.packageService
                                                            .billAmount +
                                                          " per unit"
                                                          : "No charges Applied"}
                                                        {presc.packageService
                                                          .quantity > 1
                                                          ? ", " +
                                                          presc.packageService
                                                            .quantity +
                                                          " units"
                                                          : ""}
                                                      </span>
                                                      <br></br>

                                                      <div
                                                        style={{
                                                          float: "right",
                                                          fontSize: "12px",
                                                          fontWeight: 400,
                                                        }}
                                                        className=""
                                                      >
                                                        {formatUdt(presc.cdt)}
                                                      </div>
                                                    </div>
                                                  </span>
                                                </Card>
                                              </div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          {x_ray &&
                                            presc.categoryServiceId &&
                                            presc.packageService.serviceType ===
                                            X_RAY ? (
                                            <>
                                              {/* {print && (
                                                <div className="checkbox" style={{ visibility: "hidden" }}>
                                                  <input
                                                    type="checkbox"
                                                    id={presc.id}
                                                    onChange={(event) =>
                                                      selectForPrint(
                                                        event.target.checked,
                                                        presc
                                                      )
                                                    }
                                                  ></input>
                                                </div>
                                              )} */}
                                              <div
                                                className={
                                                  print ? "set-width" : ""
                                                }
                                              >
                                                <Card
                                                  small
                                                  className="mb-0 h-100 note-card flex-wrap service-msg position-relative p-3"
                                                >
                                                  <span class="expand">
                                                    <div
                                                      open={presc.action}
                                                      toggle={() =>
                                                        toggle(index, presc)
                                                      }
                                                      dropup
                                                    >
                                                      <Select
                                                        id="toggle_1"
                                                        sx={{
                                                          ".MuiOutlinedInput-notchedOutline":
                                                          {
                                                            borderStyle:
                                                              "none",
                                                          },
                                                        }}
                                                      >
                                                        <MenuItem
                                                          className="drop-down-item"
                                                          onClick={(event) =>
                                                            confirmDelete(
                                                              true,
                                                              event,
                                                              presc,
                                                            )
                                                          }
                                                        >
                                                          Delete
                                                        </MenuItem>
                                                      </Select>
                                                    </div>
                                                  </span>
                                                  <span
                                                    className="bubble-arrow"
                                                    onClick={(event) =>
                                                      serviceListModal(presc)
                                                    }
                                                  >
                                                    <div className="pt-1">
                                                      <label className="mb-0 mt-2">
                                                        {presc.combinedNotes}
                                                      </label>
                                                      <br></br>
                                                      {/* <label className="mb-0 mt-2">{presc.packageService.description}</label><br></br> */}

                                                      <span
                                                        style={{
                                                          fontWeight: 400,
                                                        }}
                                                      >
                                                        {" "}
                                                        {presc.totalAmount > 0
                                                          ? "Rs. " +
                                                          presc.totalAmount +
                                                          " per unit"
                                                          : "No charges Applied"}
                                                        {presc.packageService
                                                          .quantity > 1
                                                          ? ", " +
                                                          presc.packageService
                                                            .quantity +
                                                          " units"
                                                          : ""}
                                                      </span>
                                                      <br></br>

                                                      <div
                                                        style={{
                                                          float: "right",
                                                          fontSize: "12px",
                                                          fontWeight: 400,
                                                        }}
                                                        className=""
                                                      >
                                                        {formatUdt(presc.cdt)}
                                                      </div>
                                                    </div>
                                                  </span>
                                                </Card>
                                              </div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </CardContent>
                                      </div>
                                    </Grid>
                                  </>
                                )}
                              </CardContent>
                            </div>
                          </Grid>
                        </>
                      )}
                    </>
                  )}
                  <Dialog
                    open={openDeleteModal}
                    toggle={() => handleopenDeleteModal()}
                  >
                    <DialogTitle>Delete</DialogTitle>
                    <DialogContent>
                      This cannot be undone. Are you sure you want to delete?
                    </DialogContent>
                    <DialogActions style={{ justifyContent: `space-between` }}>
                      <Button
                        color="primary"
                        varient="contained"
                        onClick={handleopenDeleteModal}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        varient="contained"
                        onClick={(event) => markForDel(presc, event)}
                      >
                        Delete
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </>
            );
          })}
        </div>
      </div>

      {(!props.readOnly ||
        (props.allowPrint && (print || dischargePrint))) && (
      <div className="pres-footer ">
        {print || dischargePrint ? (
          <div className="list-layout-footer print-footer">
            <div className="main-content-container container-fluid p-3 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <button onClick={cancelPrint}>
                  <span className="material-icons">close</span>
                </button>
                <span className="ml-3">{selecetdCount} Selected</span>
              </div>

              <div className="mr-3" style={{ display: "flex", gap: "20px" }}>
                <button
                  className="mr-3"
                  onClick={() => openPdfModal(true, PRINT_FILE)}
                  title="Print"
                >
                  <span className="material-icons">print</span>
                </button>

                <button
                  onClick={() => openPdfModal(true, PRINT_PREVIEW)}
                  title="Preview"
                >
                  <span className="material-icons">picture_as_pdf</span>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={
              props.basic ? "pres-layout-basic-footer" : "list-layout-footer"
            }
          >
            <div className="main-content-container container-fluid">
              <div className="row">
                <div className="mb-12 col-sm-12 col-md-12 hpcol bg menu-head">
                  <div className="blog-comments__item d-flex cpointer  p-2 menu-content">
                    <div style={{ display: `flex` }} className="px-3">
                      <div className="blog-comments__content">
                        <div className="blog-comments__meta text-mutes">
                          <div
                            aria-disabled="false"
                            role="button"
                            tabindex="0"
                            className="attach-btn"
                            data-tab="10"
                            title="Attach"
                            aria-label="Attach"
                            onClick={(event) => showAllOptions()}
                          >
                            <span data-testid="clip" data-icon="clip">
                              <svg viewBox="0 0 24 24" width="24" height="24">
                                <path
                                  fill="#54656f"
                                  d="M1.816 15.556v.002c0 1.502.584 2.912 1.646 3.972s2.472 1.647 3.974 1.647a5.58 5.58 0 0 0 3.972-1.645l9.547-9.548c.769-.768 1.147-1.767 1.058-2.817-.079-.968-.548-1.927-1.319-2.698-1.594-1.592-4.068-1.711-5.517-.262l-7.916 7.915c-.881.881-.792 2.25.214 3.261.959.958 2.423 1.053 3.263.215l5.511-5.512c.28-.28.267-.722.053-.936l-.244-.244c-.191-.191-.567-.349-.957.04l-5.506 5.506c-.18.18-.635.127-.976-.214-.098-.097-.576-.613-.213-.973l7.915-7.917c.818-.817 2.267-.699 3.23.262.5.501.802 1.1.849 1.685.051.573-.156 1.111-.589 1.543l-9.547 9.549a3.97 3.97 0 0 1-2.829 1.171 3.975 3.975 0 0 1-2.83-1.173 3.973 3.973 0 0 1-1.172-2.828c0-1.071.415-2.076 1.172-2.83l7.209-7.211c.157-.157.264-.579.028-.814L11.5 4.36a.572.572 0 0 0-.834.018l-7.205 7.207a5.577 5.577 0 0 0-1.645 3.971z"
                                ></path>
                              </svg>
                            </span>
                          </div>
                        </div>
                        {showOptions ? (
                          <Components.AttachOptions
                            data={patientProcedureList}
                            selectedPatient={{
                              ...props.selectedPatientInfo,
                              visit: patientProcedureList?.visit || props.selectedPatientInfo?.visit,
                            }}
                            lab_admin={props.lab_admin}
                            radiology={props.radiology}
                            medicalofficer={props.medicalofficer}
                            x_ray={props.x_ray}
                            patientDetail={patientProcedureList}
                            person={docDetail}
                            onOpenPainAssessment={openPainAssessmentForm}
                            closeAttachAction={(event) => setcloseAttachAction(event)}
                            closeAllOptions={(event) => showAllOptions(event)}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      )}
      {showModal ? (
        <Components.PrescriptionLayoutModel
          data={data}
          uploadedImages={getUploadImages}
          onModalClose={(event) => closeModal(event)}
        />
      ) : (
        ""
      )}
      {/* {showPatientBasic ?

        <div className='patient-desc'>
         <>
          <Components.PatientEditForm
            selectedPatient = {selectedPatient}
            onPatientBasic={(event) => openPatientBasic(event)}/>
         </>
                  {/* // </Col>
          </div>
          :''}  */}
      {/* {showReviewModel ?
          <div className='modalmn' id="meeting-notes">

          <Components.ZoomMeetingReviewModel
          selectedPatient = {patientProcedureList}
          procedureNotes = {procedureNotes}
          delete={(event) => deleteNotes(event)}
          onReviewModalClose={(event) => zoomReviewModalClose(event)}/>
           </div>
        :''} */}
      {showDischargeSummary ? (
        <div
          className="position-fixed discrgsumm-container expanded-views"
          id="discharge-summary"
        >
          <Components.Discharge
            selectedPatient={props.selectedPatientInfo}
            dischargesummary={dischargesummary}
            mode="edit"
            onModalClose={(event) => closeDischargeSummaryModal(event)}
          />
        </div>
      ) : (
        ""
      )}

      {/* {showComposition === true && (
        <div
          className="position-fixed template-container expanded-views"
          id="template-preview"
        >
          {radiology ? (
            <Components.RadiologyTemplate
              fileUploadcontent={pData[0]}
              selectedProcedure={selectedProcedure ? selectedProcedure : serviceDetails}
              mode={flag}
              templateId={templateId}
              onRadiologyTemplateModalClose={(event) =>
                closeCompositionModal(event)
              }

              // onClose={(event) => closeCompositionModal(event)}
            />
          ) : (
            <Components.TemplatePreview
              fileUploadcontent={pData[0]}
              selectedProcedure={selectedProcedure}
              mode={flag}
              templateId={templateId}
              patientInfo={props.selectedPatientInfo}
              ontemplatePreviewModalClose={(event) =>
                closeCompositionModal(event)
              }
            />
          )}
        </div>
      )} */}

      {/* // Change the showComposition section to: */}
      {showComposition === true &&
        !(selectedProcedure.subgroup == RADIOLOGYREPORT) && (
          <div
            className="position-fixed template-container expanded-views"
            id="template-preview"
          >
            <Components.TemplatePreview
              fileUploadcontent={pData[0]}
              selectedProcedure={
                selectedProcedure ? selectedProcedure : serviceDetails
              }
              procedureList={patientProcedureList}
              mode={flag}
              compositeUltrasound={compositeUltrasound}
              templateId={templateId}
              patientInfo={props.selectedPatientInfo}
              ontemplatePreviewModalClose={(event) => {
                closeCompositionModal(event);
              }}
              onModalClose={(event) => {
                closeCompositionModal(event);
              }}
              selectedTests={selectedTests}
            />
          </div>
        )}

      {showComposition === true &&
        selectedProcedure.subgroup == RADIOLOGYREPORT && (
          <div
            className="position-fixed template-container expanded-views"
            id="template-preview"
          >
            <Components.RadiologyTemplate
              fileUploadcontent={pData[0]}
              selectedProcedure={
                selectedProcedure ? selectedProcedure : serviceDetails
              }
              mode={flag}
              templateId={templateId}
              patientInfo={props.selectedPatientInfo}
              onModalClose={(event) => closeCompositionModal(event)}
            />
          </div>
        )}

      {/* {dischargepdfscreen ? (
        <div className="">
          <Components.DischargePrint
            doctorInfo={doctorInformation}
            prescriptionList={proceduresToPrint}
            dischargeSummary ={dischargeSummary}
            selectedPatient={selectedPatientInfo}
            onModalClose={(event) => closePdfModal(event)}
          />
        </div>
      ) : (
        ""
      )} */}

      {showpdfscreen &&
        labReportPrintStatus === false &&
        radiologyReportPrintStatus === false ? (
        <div className="">
          <Components.pdfprint
            doctorInfo={doctorInformation}
            prescriptionList={proceduresToPrint}
            prescriptionDate={getLatestPrescriptionDate(proceduresToPrint)}
            presc={eprescription}
            ehrid={patientEhrid}
            printPreviewType={printPreviewType}
            // localMedicineName={medicineName}
            selectedPatient={props.selectedPatientInfo}
          //onModalClose={(event) => closePdfModal(event)}
          />
        </div>
      ) : (
        ""
      )}

      {showpdfscreen && labReportPrintStatus === true ? (
        <div className="">
          <Components.LabReportPrint
            doctorInfo={doctorInformation}
            prescriptionList={proceduresToPrint}
            presc={eprescription}
            ehrid={patientEhrid}
            // localMedicineName={medicineName}
            selectedPatient={props.selectedPatientInfo}
            //onModalClose={(event) => closePdfModal(event)}
            printPreviewType={printPreviewType}
          />
        </div>
      ) : (
        ""
      )}

      {showpdfscreen && radiologyReportPrintStatus === true ? (
        <div className="">
          <Components.RadiologyPrint
            doctorInfo={doctorInformation}
            patientData={proceduresToPrint}
            templateId={templateId}
            selectedPatient={props.selectedPatientInfo}
            printPreviewType={printPreviewType}
            prescriptionList={proceduresToPrint}
            presc={eprescription}
            ehrid={patientEhrid}

          //  doctorInfo={doctorInformation}
          //     patientData={proceduresToPrint && proceduresToPrint[0]}
          //     templateId={templateId}
          //     selectedPatient={props.selectedPatientInfo}
          />
        </div>
      ) : (
        ""
      )}

      {showService ? (
        <div
          className="position-fixed packservice-container expanded-views"
          id="packgservice"
        >
          <Components.PackageService
            patientData={pData[0]}
            mode="edit"
            serviceDetails={serviceDetails}
            onModalClose={(event) => closeServiceModal(event)}
          />
        </div>
      ) : (
        ""
      )}

      {showCaseStudy && (
        <div
          className="position-fixed consultant-container expanded-views"
          id="patient-case-study-manager"
        >
          <Components.PatientCaseStudyManager
            patientData={patientProcedureList}
            patientInfo={props.selectedPatientInfo}
            attendingDoctor={docDetail}
            procedures={patientProcedureList?.procedureslist || []}
            readOnly={
              props.readOnly ||
              !helperServices.CheckAccessLevel(
                All_Component_Name.PatientCaseStudy,
              )
            }
            onClose={closeCaseStudyModal}
            onRefresh={(result) => {
              if (result) {
                setMessageStrip(result);
              }

              procedruelist(
                patientProcedureList?.id,
                patientProcedureList?.visit?.id,
              );
            }}
          />
        </div>
      )}

      {painAssessmentForm && isDoctorLogin && (
        <div
          className="position-fixed consultant-container expanded-views"
          id="pain-assessment-form"
          style={{ overflowY: "auto" }}
        >
          <Components.PainAssessmentForm
            key={`${painAssessmentForm.mode}-${painAssessmentForm.subgroup}`}
            match={{
              params: {
                patientid: painAssessmentForm.patientId,
                visitid: painAssessmentForm.visitId,
                subgroup: painAssessmentForm.subgroup,
              },
            }}
            location={{
              search:
                painAssessmentForm.mode === "new" ? "?mode=new" : "",
            }}
            onClose={closePainAssessmentForm}
          />
        </div>
      )}

      {painAssessmentPrint && (
        <PrintPainAssessment
          patientInfo={painAssessmentPrint.patientInfo}
          regDate={painAssessmentPrint.regDate}
          parentCallBack={() => setPainAssessmentPrint(null)}
        />
      )}

      {caseRecordModal && org?.orgCode === ORG_CODES.MANASWINI ? (
        <div
          className="position-fixed packservice-container expanded-views"
          id="packgservice"
        >
          <Components.Notes
            patientData={patientProcedureList}
            procedureNotes={procedureNotes}
            person={docDetail}
            onModalClose={(event) => closeNotesModal(event)}
          />
        </div>
      ) : (
        ""
      )}
      {caseRecordModal && org?.orgCode === ORG_CODES.MNH ? (
        <div
          className="position-fixed packservice-container expanded-views"
          id="packgservice"
        >
          <Components.MnhNotes
            patientData={patientProcedureList}
            procedureNotes={procedureNotes}
            person={docDetail}
            onModalClose={(event) => closeNotesModal(event)}
          />
        </div>
      ) : (
        ""
      )}
      {caseRecordModal && org?.orgCode === ORG_CODES.VEDAMAAYU ? (
        <div
          className="position-fixed packservice-container expanded-views"
          id="packgservice"
        >
          {shouldShowNurseCaseRecord ? (
            <Components.VedamaayuNurseNotes
              patientData={patientProcedureList}
              procedureNotes={procedureNotes}
              selectedProcedure={selectedProcedure}
              noteSubgroup={selectedCaseRecordSubgroup || "nurse"}
              readOnly={isSelectedCaseRecordReadOnly}
              person={docDetail}
              onModalClose={(event) => closeNotesModal(event)}
            />
          ) : (
            <Components.VedamaayuDoctorNotes
              patientData={patientProcedureList}
              procedureNotes={procedureNotes}
              selectedProcedure={selectedProcedure}
              noteSubgroup={selectedCaseRecordSubgroup || "doctor"}
              readOnly={isSelectedCaseRecordReadOnly || isReceptionOrAdmin}
              showOnlyDoctorNotes={isReceptionOrAdmin}
              person={docDetail}
              onModalClose={(event) => closeNotesModal(event)}
            />
          )}
        </div>
      ) : (
        ""
      )}
      {directDischargePrint && (
        <Components.VedamaayuDischargePrint
          parentCallBack={() => setDirectDischargePrint(null)}
          patientdetails={{
            resCb: patientProcedureList || props.selectedPatientInfo,
          }}
          revisitDetails={directDischargePrint.revisitDetails}
          doctorList={directDischargePrint.treatingDoctors || []}
          summary={directDischargePrint.summary}
        />
      )}
      {showConsutant ? (
        <div
          className="position-fixed consultant-container expanded-views"
          id="add-consultant"
        >
          <Components.AddConsultant
            patientData={pData[0]}
            details={consultantDetails}
            mode="edit"
            onModalClose={(event) => CloseAddConsultantModal(event)}
          />
        </div>
      ) : (
        ""
      )}
      <Dialog open={open} onClose={handleCancel}>
        <DialogTitle>Select Tests</DialogTitle>
        <DialogContent>
          {noteOptions.map((note) => (
            <FormControlLabel
              key={note}
              control={
                <Checkbox
                  checked={selectedNotes.includes(note)}
                  onChange={() => handleCheckboxChange(note)}
                />
              }
              label={note}
            />
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button variant="contained" onClick={handleOk}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ProcedureListing;
